
import '@aksharma25/react-schedulers-theralytics/lib/css/react-big-calendar.css';
import {
  checkIsValidAppointment,
  createAppointment,
  getAppointmentData,
  getAppointments,
  getMasterData,
  getMasterTags,
  getOfficeHours,
  getPatientAuthorizationDetails,
  getStaffsAndPatientsByLocation,
  getStaffsAvailability,
  getClientsAvailability,
  undoCancelledAppointment,
  updatePendingAppointmentStatus,
  updateSelectedSchedulerData,
  checkClinicalRoomAvailablity,
  getInActiveStaffAndPatientByLocation,
  getOnlyInActiveStaffAndPatientsByLocation,
} from './actions/SchedulingActions';
import { getStaffByTags, getClientByTags } from './../users/actions/UserActions';
import { alertConfirmation, base64Encode, calculateTimeZone, showFormattedTime, showWarningMessage, BEHAVIOR_BLOSSOMS, NE_ABA, BESTABA, DEMO, SWANCONSULTINGINC, AIP, CBG, BUILDABLOCKTHERAPY, CAS, VICTORIOUSLEARNING, ABAORLANDO, POSITIVEBEHAVIORSTEPS, EBS, VIP, CBF, SOAR, HYPERIONCENTER, KNOWBOUNDARIES, HELPINGHANDS, FUTURES, IAT, TFABA, JOYSCAPE, ADASTRA } from '../../actions/utilAction';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { renderAutoCompleteScheduling, renderCheckBox } from '../../components/reduxFields';
import Alert from 'react-s-alert';
// import AppointmentDialog from './appointmentWithAuthDialog';
// import AppointmentDialog from './appointmentWithAuthDialog_old';
import AppointmentDialog from './appointmentWithAuthDialog_New';
import AppointmentDialogNewFeature from './appointmentWithAuthDialog_NewFeatures';


import BigCalendar from '@aksharma25/react-schedulers-theralytics';

import { connect } from 'react-redux';
import { deleteAppointmentData,setIsShowInActiveFlages} from './actions/SchedulingActions';
import { getAllPatients, getPatients, getPatientsByLocation } from './../patients/actions/PatientActions';
import history from '../../history';
import moment from 'moment';
import PatientInfo from './../patients/patient_info';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import CancelAppointmentDialog from './cancelAppointmentDialog';
import { showErrorMessage } from './constants/ApiConstants';

import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import withDragAndDrop from '@aksharma25/react-schedulers-theralytics/lib/addons/dragAndDrop';
import { getAppConfigList } from '../AppConfig/actions';


BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(moment)
);

// Code commented for Drag and Drop Appointments ----
const DragAndDropCalendar = withDragAndDrop(BigCalendar);
//const DragAndDropCalendar = BigCalendar;

class Scheduling extends Component {
  constructor(props) {
    super(props);
    let width = window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;

    // let height = window.innerHeight
    //             || document.documentElement.clientHeight
    //             || document.body.clientHeight;
    let view = (width < 768) ? 'day' : 'week';
    this.state = {
      appointments: [],
      resource_list: [{ id: 0, title: 'No Staff Selected' }],
      open: true,
      showDialog: false,
      showCancelAppointmentDialog: false,
      slotInfo: null,
      patient_id: props.patientId,
      componentUpdated: false,
      currentView: view,
      IsStaffView: false,
      locations: [],
      id: null,
      patient_views: ['month', 'week', 'day'],
      all_views: ['month', 'week', 'day', 'resource'], // , 'agenda'
      selectedPatient: [],
      selectedLocation: [],
      selectedStaff: [],
      selectedActivity: [],
      allStaff: [],
      allPatient: [],
      allLocation: [],
      allActivity: [],
      allClinicalRoom: [],
      selectAllLocation: false,
      deSelectAllLocation: false,
      selectAllStaff: false,
      deSelectAllStaff: false,
      selectAllPatient: false,
      deSelectAllPatient: false,
      selectAllActivity: false,
      deSelectAllActivity: false,      
      enableClinicalRoomFilter: false, 
      schedulerDate: new Date(),
      tagStaff: false,
      allStaffTags: [],
      selectedStaffTags: [],
      tagClient: false,
      allClientTags: [],
      selectedClientTags: [],
      currentLocation: props.currentLocation,
      currentLocationId: props.currentLocationId,
      loginStaff: [],
      startHour: '00',
      startMinutes: '00',
      endHour: '24',
      endMinutes: '00',
      staffsAvailibility: null,
      clientsAvailability: null,
      updateAppointmentData: null,
      isCheckedValidate: false,
      isCheckedAuthorization: false,
      totalScheduledHours: 0,
      totalRenderedHours: 0,
      totalCanceledHours: 0,
      totalBillableHours: 0,
      lock_scheduler: null,
      selectAllClinicalRoom: false,
      deSelectAllClinicalRoom: false,
      patientInsuranceId: null,
      authorizationId: null,
      IsDisplayNumberOfHours: false,
      staffSchedulerLockedDate: null,
      lockSchedulerDateAppConfig: null,
      isShowInActiveStaffActive: props.isShowInActiveStaffActive,
      isShowInActivePatientsActive: props.isShowInActivePatientsActive,     
      isEditableInAction: true,
      allInActivePatient:[],
      allInActiveStaff:[],
    };
    this.filter = {
      currentMonth: moment().get('month'),
      DateObject: {
        fromDate: null,
        toDate: null,
      },
    };
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.openCancelAppointmentDialog = this.openCancelAppointmentDialog.bind(this);
    this.closeCancelAppointmentDialog = this.closeCancelAppointmentDialog.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleStaffView = this.handleStaffView.bind(this);
    this.onNavigateMonth = this.onNavigateMonth.bind(this);
    this.onSchedulerDateChange = this.onSchedulerDateChange.bind(this);
    this.handleAlertClickForUndoAppointment = this.handleAlertClickForUndoAppointment.bind(this);
    this.moveAppointment = this.moveAppointment.bind(this);
    this.resizeAppointment = this.resizeAppointment.bind(this);
    this.handleMoveAppointmentClick = this.handleMoveAppointmentClick.bind(this);
  }

  /**
   * @function: filter the first and last date of the month from given datetime.
   * @param {DateTime} currentDate // date of the any month.
   * @description: sets the class filter.DateObject {fromDate: 1/1/2017, toDate: 2/1/2017}
   */
  setFilteredDateObject(currentDate) {
    if (!currentDate) {
      currentDate = new Date();
    }
    let firstDay = currentDate;
    let lastDay = currentDate;
    // calculate week start and end date of the month ...
    let weekStartDate = moment(currentDate);
    let weekEndDate = moment(currentDate);

    switch (this.state.currentView) {
    case 'day':
      weekStartDate = moment(currentDate);
      weekEndDate = moment(currentDate);
      break;
    case 'week':
      // get first and last days of the month/week
      weekStartDate = moment(firstDay).startOf('week').isoWeekday(0);
      weekEndDate = moment(lastDay).endOf('week').isoWeekday(-1);
      break;
    case 'month':
      // firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      // lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      // // get first and last days of the month/week
      // weekStartDate = moment(firstDay).startOf('week').isoWeekday(0);
      // weekEndDate = moment(lastDay).endOf('week').isoWeekday(-1);
      weekStartDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      weekEndDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      break;
    default:
      weekStartDate = moment(currentDate);
      weekEndDate = moment(currentDate);
      break;
    }
    //if (this.state.currentView === 'week' || this.state.currentView === 'month') {
    if (this.state.currentView === 'week') {
      for (var i = 0; i < 7; i++) {
        weekStartDate.format('ddd D-M-Y');
        weekStartDate.add('d', 1);
        weekEndDate.format('ddd D-M-Y');
        weekEndDate.add('d', 1);
      }
    }
    let fromDate = moment(weekStartDate).format('YYYY-MM-DD');
    let toDate = moment(weekEndDate).format('YYYY-MM-DD');

    this.filter.DateObject = {
      fromDate: fromDate,
      toDate: toDate,
    };
  }

  /**
   * @function: get the filtered availability of the selected staffs.
   * @description: calls the api for staffs availabilities from the staff ids and filter.DateObject {fromDate: 1/1/2017, toDate: 2/1/2017}
   */
  get_staffsAvailability() {
    let searchTermStaff = '';
    //let DateObject = this.filter.DateObject;
    if (this.state.selectedStaff && this.state.selectedStaff.length && this.state.selectedLocation && this.state.selectedLocation.length === 1) {
      searchTermStaff = (this.state.selectedStaff || []).join(',');
      let locationId = this.state.selectedLocation[0];
      let searchObj = {
        'staffId': searchTermStaff,
        'locationId': locationId,
        // 'FromDate': DateObject.fromDate,
        // 'ToDate': DateObject.toDate,
      };
      this.props.getStaffsAvailability(searchObj);
    } else {
      this.setState({ staffsAvailibility: null });
    }
  }

  get_clientAvailability() {
    let searchTermClient = '';
    if (this.state.selectedPatient && this.state.selectedPatient.length && this.state.selectedLocation && this.state.selectedLocation.length === 1) {
      searchTermClient = (this.state.selectedPatient || []).join(',');
      let locationId = this.state.selectedLocation[0];
      let searchObj = {
        'patientId': searchTermClient,
        'locationId': locationId,
      };
      this.props.getClientsAvailability(searchObj);
    } else {
      this.setState({ clientsAvailability: null });
    }
  }

  /**
   * @function: get the patients and staffs by location(s)
   * @description: api calls for the getStaffsAndPatientsByLocation.
   */
  getStaffsAndPatientsList(locationIds, isCallFromDailog,showInActiveStaffOnly,showInActivePatientOnly)  {
    let viewOtherStaffSchedulesPermission = this.props.viewOtherStaffSchedulesPermission;
    let viewTeamSchedulesPermission = this.props.viewTeamSchedulesPermission;
    let permissionKey = '';
    if (viewTeamSchedulesPermission) {
      permissionKey = 'SCHEDULING_LIST_VIEW_TEAM_SCHEDULES';
    }
    if (viewOtherStaffSchedulesPermission) {
      permissionKey = 'SCHEDULING_LIST_VIEW_OTHERSTAFF_SCHEDULES';
    }
    let searchObj = {
      locationIds: locationIds || '',
      permissionKey: permissionKey || '',
      // isActiveCheckRequired: 'YES',
      viewTeamClientsOnly : this.props.viewTeamClientsOnlyPermission,
      
    };
    this.props.getInActiveStaffAndPatientByLocation(searchObj,isCallFromDailog,showInActiveStaffOnly,showInActivePatientOnly)
  }

  getOnlyInActiveStaffsAndPatientsList(locationIds, isCallFromDailog){
    let viewOtherStaffSchedulesPermission = this.props.viewOtherStaffSchedulesPermission;
    let viewTeamSchedulesPermission = this.props.viewTeamSchedulesPermission;
    let permissionKey = '';
    if (viewTeamSchedulesPermission) {
      permissionKey = 'SCHEDULING_LIST_VIEW_TEAM_SCHEDULES';
    }
    if (viewOtherStaffSchedulesPermission) {
      permissionKey = 'SCHEDULING_LIST_VIEW_OTHERSTAFF_SCHEDULES';
    }
    let searchObj = {
      locationIds: locationIds || '',
      permissionKey: permissionKey || '',
      // isActiveCheckRequired: 'YES',
      viewTeamClientsOnly : this.props.viewTeamClientsOnlyPermission,
    };
    this.props.getOnlyInActiveStaffAndPatientsByLocation(searchObj,isCallFromDailog);
  }


  /**
   * @function: Initialization of scheduler view
   * @description: initial api calls for the masterData, masterTags, getOfficeHours, getAppointments
   */
  getInitialData() {
    let staffFlag = this.state.isShowInActiveStaffActive ? "INACTIVEONLY" : "ACTIVEONLY"; 
    let patientsFlag = this.state.isShowInActivePatientsActive ? "INACTIVEONLY" : "ACTIVEONLY"; 
    this.props.getAppConfigList();
    this.setFilteredDateObject(this.state.schedulerDate);
    let locationIds = '';
    if (!this.state.patient_id) {
      locationIds = (this.state.selectedLocation || []).join(',');
    } else {
      locationIds = this.state.currentLocationId;
    }
    this.props.getOfficeHours(locationIds);
    if (!this.state.patient_id) {
      let masterData = { 'masterdata': 'masterTagsforPatient,masterTagsforStaff' };
      this.props.getMasterTags(masterData);
      let masterData1 = { 'masterdata': 'APPOINTMENTTYPE,MASTERCLINICALROOM,MASTERINSURANCECOMPANY' };
      this.props.getMasterData(masterData1);
      this.getOnlyInActiveStaffsAndPatientsList(locationIds);
      this.getStaffsAndPatientsList(locationIds,undefined,staffFlag,patientsFlag);
      this.setState({ allLocation: this.props.userLocationList },
        () => this.get_all_appointments());
    } else {
      this.get_patient_appointments();
    }
  }

  getIsActivePatientAndStaffByAppointment(list=[], id){
    let flag = false;
    const l = list.map(obj=>{
      return obj.id;
    });

    if(l && l.length){
      flag = l.includes(id);
    }
    return flag;
  }

  componentDidMount() {
    let selectedStaff = [];
    let selectedLocation = [];
    if (this.props.currentLoginUserId) {
      selectedStaff = [this.props.currentLoginUserId];
    }
    if (this.props.currentLocationId) {
      selectedLocation = [this.props.currentLocationId];
    }
    if (!this.state.patient_id && this.props.selectedSchedulerData) {
      const { selectAllLocation, deSelectAllLocation, selectAllStaff, deSelectAllStaff, selectAllPatient, deSelectAllPatient, schedulerDate, selectedLocation, selectedStaff, selectedPatient, selectAllActivity, deSelectAllActivity, selectAllClinicalRoom, deSelectAllClinicalRoom, filters } = this.props.selectedSchedulerData;
      this.filter = filters;
      this.setState({
        selectAllLocation,
        deSelectAllLocation,
        selectAllStaff,
        deSelectAllStaff,
        selectAllPatient,
        deSelectAllPatient,
        schedulerDate,
        selectedLocation,
        selectedStaff,
        selectedPatient,
        selectAllActivity,
        deSelectAllActivity,
        selectAllClinicalRoom,
        deSelectAllClinicalRoom,
      }, () => {
        this.getInitialData();
        this.get_staffsAvailability();
      });
    } else {
      this.setState({ selectedLocation, selectedStaff }, () => {
        this.getInitialData();
        if (!this.state.patient_id)
          this.get_staffsAvailability();
      });
    }
  }

  componentWillUnmount() {
    if (!this.state.patient_id && this.props.currentLocationId === this.state.currentLocationId) {
      let SelectedSchedulerData = {
        selectAllLocation: this.state.selectAllLocation,
        deSelectAllLocation: this.state.deSelectAllLocation,
        selectAllStaff: this.state.selectAllStaff,
        deSelectAllStaff: this.state.deSelectAllStaff,
        selectAllPatient: this.state.selectAllPatient,
        deSelectAllPatient: this.state.deSelectAllPatient,
        schedulerDate: this.state.schedulerDate,
        selectedLocation: this.state.selectedLocation,
        selectedStaff: this.state.selectedStaff,
        selectedPatient: this.state.selectedPatient,
        selectAllActivity: this.state.selectAllActivity,
        deSelectAllActivity: this.state.deSelectAllActivity,        
        selectAllClinicalRoom: this.state.selectAllClinicalRoom,
        deSelectAllClinicalRoom: this.state.deSelectAllClinicalRoom,        
        filters: this.filter,
        currentView: this.state.currentView,
      };
      this.props.updateSelectedSchedulerData(SelectedSchedulerData);
      this.props.setIsShowInActiveFlages({isShowInActiveStaffActive:this.state.isShowInActiveStaffActive,isShowInActivePatientsActive:this.state.isShowInActivePatientsActive})
    }
  }

  /**
   * @function: get the filtered appointmets for a particular patient.
   * @requires: {fromDate, toDate, patientIds, locationIds}
   * @description: calls the api for get patient appointments from the patient id, location id and filter.DateObject {fromDate: 1/1/2017, toDate: 2/1/2017}
   */
  get_patient_appointments() {
    let patientId = this.state.patient_id;
    let searchObj = {
      filters: {
        'fromDate': this.filter.DateObject.fromDate,
        'toDate': this.filter.DateObject.toDate,
        'patientIds': patientId,
        'locationIds': this.state.currentLocationId,
      },
    };

    if (Object.keys(searchObj.filters).length) {
      this.props.getAppointments(searchObj);
    }

  }

  /**
   * @function: get the filtered appointmets on the basis of different filters.
   * @requires: {fromDate, toDate, locationIds, patientIds, staffIds, patientTags, staffTags}
   * @description: calls the api for get patient appointments from the filter.DateObject {fromDate: 1/1/2017, toDate: 2/1/2017}
   */
  get_all_appointments() {
    let searchObj = {
      filters: {},
    };

    let filters = {
      'fromDate': this.filter.DateObject.fromDate,
      'toDate': this.filter.DateObject.toDate,
    };
    let searchTermLocation = '';
    let searchTermPatient = '';
    let searchTermStaff = '';
    let searchTermStaffTags = '';
    let searchTermClientTags = '';
    let searchTermActivity = '';
    let searchTermClinicalRoom = '';

    searchTermLocation = (this.state.selectedLocation || []).join(',');
    searchTermPatient = (this.state.selectedPatient || []).join(',');
    searchTermStaff = (this.state.selectedStaff || []).join(',');
    searchTermActivity = (this.state.selectedActivity || []).join(',');
    searchTermClinicalRoom = (this.state.selectedClinicalRoom || []).join(',');

    if (this.state.selectedStaffTags && this.state.selectedStaffTags.length) {
      this.state.selectedStaffTags.forEach((selectedData, i) => {
        if (i === 0) {
          searchTermStaffTags += selectedData.value;
        } else {
          searchTermStaffTags += `,${selectedData.value}`;
        }
      });
    }
    if (this.state.selectedClientTags && this.state.selectedClientTags.length) {
      this.state.selectedClientTags.forEach((selectedData, i) => {
        if (i === 0) {
          searchTermClientTags += selectedData.value;
        } else {
          searchTermClientTags += `,${selectedData.value}`;
        }
      });
    }

    if (searchTermPatient !== '') {
      filters['patientIds'] = searchTermPatient;
    }
    if (searchTermLocation !== '') {
      filters['locationIds'] = searchTermLocation; // searchTermLocation;
    }
    if (searchTermStaff !== '') {
      filters['staffIds'] = searchTermStaff;
    }
    if (searchTermActivity !== '') {
      filters['activityIds'] = searchTermActivity;
    }
    if (searchTermClinicalRoom !== '') {
      filters['clinicalRoomIds'] = searchTermClinicalRoom;
    }

    if (searchTermStaffTags !== '') {
      filters['staffTags'] = searchTermStaffTags;
    }

    if (searchTermClientTags !== '') {
      filters['patientTags'] = searchTermClientTags;
    }

    filters['isDisplayNumberOfHours'] = ((this.props.agencyName.toUpperCase() === 'SANTACRUZABA' || this.props.agencyName.toUpperCase() === 'CBC' || this.props.agencyName.toUpperCase() === 'CBF') ? true : this.state.IsDisplayNumberOfHours);    

    if (Object.keys(filters).length) {
      searchObj.filters = filters;
      this.props.getAppointments(searchObj);
    }

  }

  /**
   *
   * @param {Array} appointments
   * @function: set appointments array.
   * @description: set the appointments array to the state for the scheduler.
   */
  formattedAppointments(appointments,isEditableInAction) {
    // let noImagePath = 'https://api.theralytics.net/templates/img/NoImageAvailable.png';
    let noImagePath = '';
    let formatted_apoointments = [];
    let appointmentsList = appointments.data && appointments.data.length ? appointments.data : [];
    let totalScheduledHours = appointments.data && appointments.data.length ? appointments.data[0].totalScheduledHours : 0;
    let totalRenderedHours = appointments.data && appointments.data.length ? appointments.data[0].totalRenderedHours : 0;
    let totalCanceledHours = appointments.data && appointments.data.length ? appointments.data[0].totalCanceledHours : 0;
    let totalBillableHours = appointments.data && appointments.data.length ? appointments.data[0].totalBillableHours : 0;
    
    this.setState({ totalScheduledHours: totalScheduledHours, totalRenderedHours: totalRenderedHours, totalCanceledHours: totalCanceledHours, totalBillableHours: totalBillableHours })
    let isValidInsuranceAppointmentList = appointmentsList.filter((data) =>{
      return !data.isValidInsurance
    })
    appointmentsList.forEach((appointment, index) => {
      let staffNames = [];
      let staffId = null;
      staffId = (appointment.appointmentStaffs.length === 1) ? appointment.appointmentStaffs[0].staffId : null;
      staffNames = appointment.appointmentStaffs.map((staff) => {
        return staff.staffName;
      });
      this.setState({patientInsuranceId:appointment.patientInsuranceId})
      let startDateTime = appointment.startDateTime
        , endDateTime = appointment.endDateTime
        , startTime = showFormattedTime(startDateTime)
        , endTime = showFormattedTime(endDateTime)
        , staffName = staffNames && staffNames.length ? staffNames.join(', ') : 'No Staff'
        , patientName = appointment.patientName ? appointment.patientName : staffName
        //, title = this.state.patient_id ? staffName : (appointment.patientName ? appointment.patientName : 'Non-Billable')
        , patientPhoto = appointment.patientPhotoThumbnailPath ? appointment.patientPhotoThumbnailPath : noImagePath
        , appointmentTypeName = appointment.appointmentTypeName
        , title = this.state.patient_id ? staffName : (patientName && appointment.isBillable === true ? patientName : appointmentTypeName.toString().trim())
        //, title = this.state.patient_id ? staffName : (patientName ? patientName : appointmentTypeName.toString().trim())
        , allowMultipleStaff = false
        , soapNoteTitle = appointment.isBillable ? 'Session Note' : 'Non-Billable Note'
        , isAppoinmentCancelled = appointment.cancelTypeId ? true : false
        , isValidAuth = appointment.isValidAuth ? true : false
        , isValidInsurance = appointment.isValidInsurance ? true : false
        // , setProfileTitle = this.state.patient_id ? 'View Client Profile' : (appointment.patientID ? 'View Client Profile' : '')
        , isEditAction = this.props.updatePermission ? true : false
        , isDeleteAction = this.props.deletePermission ? true : false
        , isCancelAction = this.props.cancelPermission ? true : false
        , isAppointmentRendered = false
        , practitionerName = !this.state.patient_id ? staffName : ''
        , isUnCancelAction = false
        , isApproveAction = this.props.approveAppointmentPermission ? true : false
        , cancellationReason = ''
        , isDragAction = false;

        isValidInsuranceAppointmentList.map((data) =>{
          if(data.patientAppointmentId == appointment.patientAppointmentId){
            soapNoteTitle = 'Insurance has expired. Please click here to update the client Insurance.';
          }
        })

      if (isAppoinmentCancelled) {
        isEditAction = false;
        isDeleteAction = false;
        isCancelAction = false;
        isUnCancelAction = this.props.unCancelPermission;
        cancellationReason = appointment.cancelTypeName + ' - Cancellation Reason : ' + appointment.cancelReason || '-';
      }
      if (this.props.hasDefaultAccess) {
        isEditAction = !isAppoinmentCancelled;
        isDeleteAction = true;
        if (!appointment.claimId) {
          isCancelAction = !isAppoinmentCancelled;
          isUnCancelAction = isAppoinmentCancelled && this.props.unCancelPermission;
        }
      }
      // if (appointment.patientID) {
      // let appointmentStatus = appointment.status || '';
      // if (appointmentStatus.toLowerCase() === 'rendered') { // Render condition
      if (appointment.claimId) {
        if(appointment.canEdit){
          isEditAction = (this.props.modifyAfterRenderPermission || !this.props.editAppointmentAfterClaimSubmission) ? true : false;
        } else {
          // this condition falls in when the appointment's claim has been submitted
          isEditAction = (!this.props.editAppointmentAfterClaimSubmission || this.props.modifySessionTimeAfterClaimSubmission) ? true : false;
        }
        isDeleteAction = this.props.modifyAfterRenderPermission ? appointment.canEdit : false;
        isCancelAction = false;
        isAppointmentRendered = true;
      }
      let self = this;
      
      if (!isAppoinmentCancelled && appointment.patientEncounterId && ((appointment.claimId && appointment.claimId > 0) || this.state.lock_scheduler === null || !this.checkIsSameOrBefore(moment(startDateTime).format('YYYY/MM/DD'), moment(this.state.lock_scheduler).format('YYYY/MM/DD')))) {
        let viewOwnSoapPermission = true;
        // the top level permission added to view only own Appointment's SOAP.
        if (!self.props.hasDefaultAccess && self.props.viewOnlyOwnSoapPermission) {
          viewOwnSoapPermission = (staffId === self.props.currentLoginUserId);
        }
        let viewSoapPermission = (self.props.viewSoapPermission || viewOwnSoapPermission) && appointment.isValidInsurance;
        soapNoteTitle = viewSoapPermission ? `View ${soapNoteTitle}` : (!viewOwnSoapPermission ? '' : 'Insurance has expired. Please click here to update the client Insurance.');      
      } else if (isValidAuth && !this.state.isShowInActiveStaffActive && !this.state.isShowInActivePatientsActive && !isAppoinmentCancelled && moment(startDateTime).format('YYYYMMDD') <= moment.utc().format('YYYYMMDD') && (this.state.lock_scheduler === null || !this.checkIsSameOrBefore(moment(startDateTime).format('YYYY/MM/DD'), moment(this.state.lock_scheduler).format('YYYY/MM/DD')))) {
        let createOwnSoapPermission = true;
        // the top level permission added to create only own Appointment's SOAP.
        if (!self.props.hasDefaultAccess && self.props.createOnlyOwnSoapPermission) {
          createOwnSoapPermission = (staffId === self.props.currentLoginUserId);
        }
        let createSoapPermission = self.props.createSoapPermission && createOwnSoapPermission && appointment.isValidInsurance;
        soapNoteTitle = createSoapPermission ? `Create ${soapNoteTitle}` : (!createOwnSoapPermission ? '' : 'Insurance has expired. Please click here to update the client Insurance.');      
      } else if (isValidAuth && !isAppoinmentCancelled && moment(startDateTime).format('YYYYMMDD') <= moment.utc().format('YYYYMMDD') && (this.state.lock_scheduler === null || !this.checkIsSameOrBefore(moment(startDateTime).format('YYYY/MM/DD'), moment(this.state.lock_scheduler).format('YYYY/MM/DD')))) {
        let createOwnSoapPermission = true;
        // the top level permission added to create only own Appointment's SOAP.
        if (!self.props.hasDefaultAccess && self.props.createOnlyOwnSoapPermission) {
          createOwnSoapPermission = (staffId === self.props.currentLoginUserId);
        }

        //////////////////My Testing Code/////////

        // let staff = appointment.appointmentStaffs[0];
        // let filteredStaffById = this.state.allInActiveStaff.find(inActStaff=>{
        //   return staff.staffId === inActStaff.id
        // })

        let isSinglePatientInActive = this.getIsActivePatientAndStaffByAppointment(this.state.allInActivePatient,appointment.patientID);
        let isSingleStaffInActive = this.getIsActivePatientAndStaffByAppointment(this.state.allInActiveStaff,appointment.appointmentStaffs[0].staffId);
        let createSoapPermission = self.props.createSoapPermission && createOwnSoapPermission;
        // if(isSinglePatientInActive){
        //   soapNoteTitle = createSoapPermission && !isSinglePatientInActive ? `Create ${soapNoteTitle}` : '';
        // }else if(isSingleStaffInActive){
        //   soapNoteTitle = createSoapPermission && !isSingleStaffInActive ? `Create ${soapNoteTitle}` : '';
        // }else{
        //   soapNoteTitle = createSoapPermission ? `Create ${soapNoteTitle}` : '';
        // }


        let isBillable = appointment.isBillable;
        let linkText = ''
        if(isSinglePatientInActive && !isSingleStaffInActive){
          linkText = '';
        }
        else if(!isSinglePatientInActive && isSingleStaffInActive ){
          linkText = '';
        }
        else if(isSinglePatientInActive && isSingleStaffInActive){
          linkText =  '';
        }
        else{
          linkText = `Create ${soapNoteTitle}`;
        }
        let updatedLink = createSoapPermission ? linkText: '';
        let updatedLinkByCheckingIsBillable = !isBillable ? '': updatedLink;

        if(!appointment.patientID){

            //false, false 
          if(!isBillable && !isSingleStaffInActive){
            soapNoteTitle = createSoapPermission ? `Create ${soapNoteTitle}`:'';
          }else if (!isBillable && isSingleStaffInActive) {
            soapNoteTitle = ''
          }
        } else {
          soapNoteTitle = updatedLinkByCheckingIsBillable;
        }

        // let createSoapPermission = self.props.createSoapPermission && createPermission;
        // soapNoteTitle = createSoapPermission ? `Create ${soapNoteTitle}` : '';
      }else if (!isValidAuth && !isAppoinmentCancelled) {
        soapNoteTitle = 'Auth has expired. Please click edit and update the auth.';
      }
      else if (!isValidInsurance || !appointment.isValidInsurance) {
        soapNoteTitle = 'Insurance has expired. Please click here to update the client Insurance.';
      }
       
      // else if (!isAppoinmentCancelled && moment(startDateTime).format('YYYYMMDD') <= moment.utc().format('YYYYMMDD')) {
      //   let createPermission = true;
      //   // the top level permission added to create only own Appointment's SOAP.
      //   if (!self.props.hasDefaultAccess && self.props.createOnlyOwnSoapPermission) {
      //     createPermission = (staffId === self.props.currentLoginUserId);
      //   }
      //   let createSoapPermission = self.props.createSoapPermission && createPermission;
      //   soapNoteTitle = createSoapPermission ? `Create ${soapNoteTitle}` : '';
      // } 
      else {
        soapNoteTitle = '';
      }

      if (this.props.isDragForAppointments) {
        if(appointment.claimId > 0 && !appointment.canEdit){
          isDragAction =  false;
        }
        else if(appointment.claimId > 0 && appointment.canEdit && this.props.modifyAfterRenderPermission === false){
          isDragAction =  false;
        }
        else {
          isDragAction =  (isEditAction && this.props.disableAppointmentEditing === false) ? true : false;
        }
        //isDragAction = (isEditAction && !appointment.patientEncounterId) ? true : false;
      }
      // condition appointment from patient portal, Can't edit if not in case pending ...
      if ((appointment.statusName || '').toLowerCase() !== 'pending') {
        if (this.props.isRequestFromPatientPortal) {
          isEditAction = false;
        } else {
          isApproveAction = false;
        }
      } else {
        soapNoteTitle = '';
      }

      let appointmentBackgroundColor = appointment.color;

      if(this.props.agencyName.toUpperCase() === KNOWBOUNDARIES )
      {
        if((appointment.appointmentTypeName === 'UNFILLED DIRECT SESSION' || appointment.appointmentTypeName === 'PENDING UNFILLED DIRECT SESSION') && appointment.isBillable && appointment.isDirectService && appointment.serviceFacility === "11")
        {
          appointmentBackgroundColor = '#f399ed'; 
        }
        else if (appointment.appointmentTypeName !== 'UNFILLED DIRECT SESSION' && appointment.appointmentTypeName !== 'PENDING UNFILLED DIRECT SESSION' && appointment.isBillable && appointment.isDirectService && appointment.serviceFacility === "11") 
        {
          appointmentBackgroundColor = '#f30ac9';
        }    
        else
        {
          appointmentBackgroundColor = appointment.color;
        }    
      }
      else if(this.props.agencyName.toUpperCase() === IAT && !appointment.isDirectService && appointment.isSupervisionActivity)
      {
        appointmentBackgroundColor = '#ec7f07';
      }
      else
      {
        appointmentBackgroundColor = appointment.color;
      }

      let appointmentFontColor = appointment.fontColor;

      if(this.props.agencyName.toUpperCase() === KNOWBOUNDARIES)
      {
        if((appointment.appointmentTypeName === 'UNFILLED DIRECT SESSION' || appointment.appointmentTypeName === 'PENDING UNFILLED DIRECT SESSION') && appointment.isBillable && appointment.isDirectService && appointment.serviceFacility === "11")
        {
          appointmentFontColor = '#0c0b0b';
        }
        else if (appointment.appointmentTypeName !== 'UNFILLED DIRECT SESSION' && appointment.appointmentTypeName !== 'PENDING UNFILLED DIRECT SESSION' && appointment.isBillable && appointment.isDirectService && appointment.serviceFacility === "11") 
        {
          appointmentFontColor = '#0c0b0b';  
        } 
        else
        {
          appointmentFontColor = appointment.fontColor;
        }        
      }
      else if(this.props.agencyName.toUpperCase() === IAT && !appointment.isDirectService && appointment.isSupervisionActivity)
      {
        appointmentFontColor = '#ffffff';
      }
      else
      {
        appointmentFontColor = appointment.fontColor;
      }

      let isEditable =  isEditAction && isEditableInAction ? true: false;
      formatted_apoointments.push({
        title: title,
        // startDateTime: startDateTime,
        // endDateTime: endDateTime,
        start: new Date(startDateTime),
        end: new Date(endDateTime),
        appointmentNotes: appointment.notes,
        id: appointment.patientAppointmentId,
        resourceId: staffId,
        patientID: appointment.patientID,
        name: patientName,
        appointmentTypeID: appointment.appointmentTypeID,
        // StaffIDs: appointment.StaffIDs,
        // location_type_id: appointment.PatientLocationID,
        clinicianImage: this.state.patient_id ? noImagePath : patientPhoto,
        clinicianName: title,
        appointmentType: appointmentTypeName,
        // appointmentBackgroundColor: appointment.color,
        // appointmentFontColor: appointment.fontColor,
        appointmentBackgroundColor: appointmentBackgroundColor,
        appointmentFontColor: appointmentFontColor,
        appointmentTime: `${startTime} - ${endTime}`,
        appointmentAddress: appointment.address ? appointment.address : appointment.customAddress ? appointment.customAddress : '-',
        coPay: '0.00',
        serviceAddressID: appointment.serviceAddressID,
        serviceLocationID: appointment.serviceLocationID,
        officeAddressID: appointment.officeAddressID,
        patientAddressID: appointment.patientAddressID,
        customAddressID: appointment.customAddressID,
        customAddress: appointment.customAddress,
        latitude: appointment.latitude,
        longitude: appointment.longitude,
        notes: appointment.notes,
        isTelehealthAppointment: appointment.isTelehealthAppointment,
        isRecurrence: appointment.isRecurrence,
        recurrenceRule: appointment.recurrenceRule,
        isClientRequired: appointment.isClientRequired,
        isExcludedFromMileage: appointment.isExcludedFromMileage,
        isDirectService: appointment.isDirectService,
        mileage: appointment.mileage,
        driveTime: appointment.driveTime,
        appointmentId: 0,
        parentAppointmentId: appointment.parentAppointmentId,
        soapNoteTitle: soapNoteTitle,
        PatientEncounterId: appointment.patientEncounterId ? appointment.patientEncounterId : 0,
        //isBillable: (appointment.patientID && appointment.masterNoteTypeKey === "NON_BILLABLE_NOTE") || (!appointment.isBillable && appointment.nonBillableNotes !== '') ? false : (appointment.patientID || appointment.isBillable ? true : false),
        isBillable: appointment.isBillable,
        allowMultipleStaff: allowMultipleStaff,
        appointmentStaffs: appointment.appointmentStaffs,
        // setProfileTitle: setProfileTitle,
        isRecurrenceEdit: false,
        isEdit: isEditable,
        isDelete: isDeleteAction,
        isCancel: isCancelAction,
        isAppointmentRendered: isAppointmentRendered,
        isVideoCall: appointment.isTelehealthAppointment,
        isAppoinmentCancelled: isAppoinmentCancelled,
        practitionerName: practitionerName,
        isUnCancel: isUnCancelAction,
        isApprove: isApproveAction,
        cancellationReason: cancellationReason,
        claimId: appointment.claimId,
        canEdit: appointment.canEdit,
        isDragable: isDragAction,
        statusName: appointment.statusName,     
        isExcludedFromPayroll: appointment.isExcludedFromPayroll,   
        noteTypeId: appointment.noteTypeId,
        isClientCheckedIn: appointment.isClientCheckedIn,
        patientInsuranceId: appointment.patientInsuranceId,
        authorizationId: appointment.authorizationId,
        serviceAddress: appointment.serviceAddress,
        isMakeUpSession: appointment.isMakeUpSession,
        batchParentAppointmentId: appointment.batchParentAppointmentId,
        masterNoteTypeKey: appointment.masterNoteTypeKey || "SOAP_NOTE",
        isValidInsurance:appointment.isValidInsurance ? true : false,
        isRBTTracking: appointment.isRBTTracking,
      });
    });

    if (this.state.currentView === 'month') {
      formatted_apoointments = formatted_apoointments.map((Obj) => {
        Obj.title = Obj.appointmentTime + '\n' + Obj.title;
        return Obj;
      });
    }

    let formatted_appointments = formatted_apoointments;
    /////////////////////////////
    if(this.state.selectedActivity && this.state.selectedActivity.length){
      if(this.state.selectedStaff && this.state.selectedStaff.length){
      let inActiveStaffIds = this.state.allInActiveStaff.map(staff=>staff.id);
      let filteredApp = [];
      if(this.state.isShowInActiveStaffActive){
        formatted_apoointments.forEach(d=>{
          if(inActiveStaffIds.includes(d.resourceId)){
            filteredApp.push(d);
          }
        })
      }else{
        formatted_apoointments.forEach(d=>{
          if(!inActiveStaffIds.includes(d.resourceId)){
            filteredApp.push(d);
          }
        })
      }
      formatted_appointments = filteredApp;
      }else{
        // formatted_appointments = [];
        formatted_appointments;
      }
    }

    //////////////////

    this.setState({ appointments: formatted_appointments });
  }

  componentDidUpdate(nextProps,nextState) {
    if(nextState.isShowInActivePatientsActive !== this.state.isShowInActivePatientsActive || nextState.isShowInActiveStaffActive !== this.state.isShowInActiveStaffActive){
      if( !this.state.isShowInActiveStaffActive && !this.state.isShowInActivePatientsActive){
        this.setState({isEditableInAction:true},() => {
          this.formattedAppointments(nextProps.appointments,this.state.isEditableInAction);
        });
      }else{
        this.setState({isEditableInAction: false}, () => {
          this.formattedAppointments(nextProps.appointments,this.state.isEditableInAction);
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.appointments && nextProps.appointments !== this.props.appointments) {
      this.formattedAppointments(nextProps.appointments,this.state.isEditableInAction);      
    }

    if (nextProps.masterTags && this.props.masterTags !== nextProps.masterTags) {
      let clientTags = nextProps.masterTags.masterTagsforPatient || [],
        staffTags = nextProps.masterTags.masterTagsforStaff || [];
      this.setState({ allClientTags: clientTags, allStaffTags: staffTags });
    }

    if (nextProps.activityList && this.props.activityList !== nextProps.activityList) {
      this.setState({ allActivity: nextProps.activityList });
    }

    if (nextProps.clinicalRoomList && this.props.clinicalRoomList !== nextProps.clinicalRoomList) {
      this.setState({ allClinicalRoom: nextProps.clinicalRoomList });
    }

    // if(this.props.agencyName.toUpperCase() === VIP)
       this.setState({ enableClinicalRoomFilter: true });
    // else
    //   this.setState({ enableClinicalRoomFilter: false });

    if (nextProps.patientId !== this.props.patientId) {
      this.setState({
        currentLocation: nextProps.currentLocation,
        patient_id: nextProps.patientId || null }, () => {

        // again coded same as component did mount ...
        let selectedStaff = [];
        let selectedLocation = [];
        if (nextProps.currentLoginUserId) {
          selectedStaff = [nextProps.currentLoginUserId];
        }
        if (nextProps.currentLocationId) {
          selectedLocation = [nextProps.currentLocationId];
        }
        if (!this.state.patient_id && nextProps.selectedSchedulerData) {
          const { selectAllLocation, deSelectAllLocation, selectAllStaff, deSelectAllStaff, selectAllPatient, deSelectAllPatient, schedulerDate, selectedLocation, selectedStaff, selectedPatient, selectAllActivity, deSelectAllActivity, selectAllClinicalRoom, deSelectAllClinicalRoom, filters } = nextProps.selectedSchedulerData;
          this.filter = filters;
          this.setState({
            selectAllLocation,
            deSelectAllLocation,
            selectAllStaff,
            deSelectAllStaff,
            selectAllPatient,
            deSelectAllPatient,
            schedulerDate,
            selectedLocation,
            selectedStaff,
            selectedPatient,            
            selectAllActivity,
            deSelectAllActivity,
            selectAllClinicalRoom,
            deSelectAllClinicalRoom,
          }, () => {
            this.getInitialData();
            this.get_staffsAvailability();
          });
        } else {
          this.setState({ selectedLocation, selectedStaff }, () => {
            this.getInitialData();
            if (!this.state.patient_id)
              this.get_staffsAvailability();
          });
        }
      });
    }

    if (nextProps.appointment_deleted && this.props.appointment_deleted !== nextProps.appointment_deleted) {
      if (this.state.patient_id) {
        this.get_patient_appointments();
      } else {
        this.get_all_appointments();
      }
    }
    if (nextProps.appointment_created && this.props.appointment_created !== nextProps.appointment_created) {
      if (this.state.patient_id) {
        this.get_patient_appointments();
      } else {
        this.get_all_appointments();
      }
    }
    if (nextProps.cancelledAppointment && this.props.cancelledAppointment !== nextProps.cancelledAppointment) {
      if (this.state.patient_id) {
        this.get_patient_appointments();
      } else {
        this.get_all_appointments();
      }
    }
    if (nextProps.unCancelledAppointment && this.props.unCancelledAppointment !== nextProps.unCancelledAppointment) {
      if (this.state.patient_id) {
        this.get_patient_appointments();
      } else {
        this.get_all_appointments();
      }
    }
    if (nextProps.updateAppointmentStatusDetail && this.props.updateAppointmentStatusDetail !== nextProps.updateAppointmentStatusDetail) {
      if (this.state.patient_id) {
        this.get_patient_appointments();
      } else {
        this.get_all_appointments();
      }
    }

    if (nextProps.officeHours && this.props.officeHours !== nextProps.officeHours) {
      // this.setState({ officeTime: nextProps.officeHours });
      if (nextProps.officeHours.data) {
        // console.log('startTime.................', moment(nextProps.officeHours.data.startTime).format('YYYY-MM-DD') + 'T' + moment(nextProps.officeHours.data.startTime).format('HH:mm:ss'));
        // console.log('endTime.................', moment(nextProps.officeHours.data.endTime).format('YYYY-MM-DD') + 'T' + moment(nextProps.officeHours.data.endTime).format('HH:mm:ss'));

        // let startTime = nextProps.officeHours.data.startTime || '00:00:00',
        //   endTime = nextProps.officeHours.data.endTime || '23:59:00',
        //   startHour = startTime.substring(0, 2),
        //   startMinutes = startTime.substring(3, 5),
        //   endHour = endTime.substring(0, 2),
        //   endMinutes = endTime.substring(3, 5);

        // let StartDateTime = moment(nextProps.officeHours.data.startTime).format('YYYY-MM-DD') + 'T' + moment(nextProps.officeHours.data.startTime).format('HH:mm:ss');
        // let EndDateTime = moment(nextProps.officeHours.data.endTime).format('YYYY-MM-DD') + 'T' + moment(nextProps.officeHours.data.endTime).format('HH:mm:ss');

        let startTime = moment(nextProps.officeHours.data.startTime).format('HH:mm:ss') || '06:00:00',
        endTime = moment(nextProps.officeHours.data.endTime).format('HH:mm:ss') || '23:00:00',
        startHour = startTime.substring(0, 2),
        startMinutes = startTime.substring(3, 5),
        endHour = endTime.substring(0, 2),
        endMinutes = endTime.substring(3, 5);

        this.setState({ startHour: startHour, startMinutes: startMinutes, endHour: endHour, endMinutes: endMinutes });
      }
    }
    if (nextProps.staffsAvailibility && this.props.staffsAvailibility !== nextProps.staffsAvailibility) {
      // console.log('available staff dates ....', nextProps.staffsAvailibility);
      if (this.state.selectedStaff && this.state.selectedStaff.length === 1) {
        // var staffSchedulerLockedDate = nextProps.staffsAvailibility.data && nextProps.staffsAvailibility.data.staffSchedulerLockedDate && nextProps.staffsAvailibility.data.staffSchedulerLockedDate !== undefined ? nextProps.staffsAvailibility.data.staffSchedulerLockedDate.filter((obj) => obj.staffId === this.state.selectedStaff[0])[0].schedulerLockedDate : null;
        var staffSchedulerLockedDate = null;
        if(
          nextProps.staffsAvailibility.data &&
          nextProps.staffsAvailibility.data.staffSchedulerLockedDate &&
          nextProps.staffsAvailibility.data.staffSchedulerLockedDate !== undefined &&
          this.state.selectedStaff[0]){
            let filteredValue = nextProps.staffsAvailibility.data.staffSchedulerLockedDate
            .filter((obj) => obj.staffId === this.state.selectedStaff[0]);
            if(filteredValue.length){
              staffSchedulerLockedDate = filteredValue[0].schedulerLockedDate;
            }
        }
        this.setState({ staffSchedulerLockedDate });
        this.setState({ lock_scheduler : staffSchedulerLockedDate ? staffSchedulerLockedDate : this.state.lock_scheduler });
      }
      
      this.setState({ staffsAvailibility: nextProps.staffsAvailibility.data });
      // this.setState({clientsAvailability :nextProps.clientsAvailability.data});
    }
    if (nextProps.clientsAvailibility && this.props.clientsAvailibility !== nextProps.clientsAvailibility){
      this.setState({clientsAvailability :nextProps.clientsAvailability.data});
    }
    if (nextProps.staffsAndPatientsByLocation && this.props.staffsAndPatientsByLocation !== nextProps.staffsAndPatientsByLocation) {
      // console.log("staff and patient lists --------", nextProps.staffsAndPatientsByLocation);
      let allList = nextProps.staffsAndPatientsByLocation.data;
      
this.setState({
        allPatient: allList.patients,
        allStaff: allList.staff,
      });
    }

    if (nextProps.onlyInActiveStaffAndPatientsByLocation && this.props.onlyInActiveStaffAndPatientsByLocation !== nextProps.onlyInActiveStaffAndPatientsByLocation) {
      // console.log("staff and patient lists --------", nextProps.staffsAndPatientsByLocation);
      let allList = nextProps.onlyInActiveStaffAndPatientsByLocation.data;

      this.setState({
        allInActivePatient: allList.patients,
        allInActiveStaff: allList.staff,
      });
    }

    if (nextProps.checkValidAppointment_inUndoCancel && this.props.checkValidAppointment_inUndoCancel !== nextProps.checkValidAppointment_inUndoCancel) {
      let isValidAppointment = nextProps.checkValidAppointment_inUndoCancel.isValid;
      // checks for the call from undo cancel or drag and drop
      if ((nextProps.checkValidAppointment_inUndoCancel.requestName || '') === 'undoCancelledAppointment') {
        if (isValidAppointment) {
          let apptId = nextProps.checkValidAppointment_inUndoCancel.formData[0].PatientAppointmentId;
          this.props.undoCancelledAppointment(apptId);
        } else {
          let message = nextProps.checkValidAppointment_inUndoCancel.errorMessage;
          showErrorMessage(message, 5000);
        }
      } else if ((nextProps.checkValidAppointment_inUndoCancel.requestName || '') === 'updateAppointment') {
        if (!isValidAppointment) {
          let message = nextProps.checkValidAppointment_inUndoCancel.errorMessage;
          showWarningMessage(message);
        }
        this.setState({ isCheckedValidate: isValidAppointment }, () => {
          if (this.state.isCheckedValidate && this.state.isCheckedAuthorization) {
            let appointmentData = this.state.updateAppointmentData;
            let IsFinish = true;
            let isAdminUpdate = true;
            // console.log('checked validate...', JSON.stringify(appointmentData));
            this.props.createAppointment(appointmentData, IsFinish, this.props.agencyName.toUpperCase(), isAdminUpdate);
            this.setState({ updateAppointmentData: null, isCheckedValidate: false, isCheckedAuthorization: false });
          }
        });
      }
    }

    if (nextProps.patientAuthorizationDetailsWithUpdateAppointment && nextProps.patientAuthorizationDetailsWithUpdateAppointment !== this.props.patientAuthorizationDetailsWithUpdateAppointment) {
      let authorization = nextProps.patientAuthorizationDetailsWithUpdateAppointment.data;
      let authMessage = ''
        , isValid = true;
      if (authorization && authorization.length) {
        let message = authorization[0].authorizationMessage;
        if (message.toLowerCase() === 'valid') {
          isValid = true;
          authMessage = '';
        } else {
          isValid = false;
          authMessage = message;
        }
      }
      // let { updateAppointmentData } = this.state;
      if (!isValid) {
        showWarningMessage(authMessage);
      }
      this.setState({ isCheckedAuthorization: isValid }, () => {
        if (this.state.isCheckedValidate && this.state.isCheckedAuthorization) {
          let appointmentData = this.state.updateAppointmentData;
          let IsFinish = true;
          let isAdminUpdate = (this.props.modifyAfterRenderPermission && appointmentData[0].claimId > 0 && appointmentData[0].canEdit) ? true : false;
          //console.log('condition permission....', (this.props.modifyAfterRenderPermission && appointmentData.claimId > 0 && appointmentData.canEdit));
          this.props.createAppointment(appointmentData, IsFinish, this.props.agencyName.toUpperCase(), isAdminUpdate);
          this.setState({ updateAppointmentData: null, isCheckedValidate: false, isCheckedAuthorization: false });
        }
      });
    }

///////////////////////////////////
// clientsListByTags  
    if (nextProps.clientsListByTags && this.props.clientsListByTags !== nextProps.clientsListByTags) {
      let client_data = [];
      nextProps.clientsListByTags.forEach((client, index) => {

        console.log("client",client);

        client_data.push(client.patientId);
      }); 

      if(client_data.length > 0)
      {
        // console.log('client_data......',client_data)
        this.setState({ selectedClientTags: [], selectedPatient: client_data }, () => {
          // this.get_staffsAvailability();
          this.get_all_appointments();          
        });

        client_data = [];

        nextProps.clientsListByTags.forEach((client, index) => {
          client_data.push({
              id: client.patientId,
              title: client.name,
            });
        });
        this.setState({ resource_list: client_data });
      }
      

    }

////////////////////

    if (nextProps.staffListByTags && this.props.staffListByTags !== nextProps.staffListByTags) {
      let staff_data = [];      
      nextProps.staffListByTags.forEach((staff, index) => {
        staff_data.push(staff.staffID);
      });     
      
      if(staff_data.length > 0)
      {
        // console.log('staff_data......',staff_data)
        this.setState({ selectedStaffTags: [], selectedStaff: staff_data }, () => {
          this.get_staffsAvailability();
          this.get_all_appointments();          
        });

        staff_data = [];
        nextProps.staffListByTags.forEach((staff, index) => {
            staff_data.push({
              id: staff.staffID,
              title: staff.name,
            });
        });
        this.setState({ resource_list: staff_data });
      }
    }
    
    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let lock_scheduler = null;     
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 3) {
            switch (Obj.key) {
            case 'LOCK_SCHEDULER':
              lock_scheduler = Obj.value ? Obj.value.toString() : null;
              break;            
            default:
              break;
            }
          }
        });     
        this.setState({ lock_scheduler : staffSchedulerLockedDate ? staffSchedulerLockedDate : lock_scheduler, lockSchedulerDateAppConfig: lock_scheduler });
      }     
    }    
  }

  isAvailableDateTime(availibilityArray, slotInfo, isDayAvailibility, isMonthView) {
    let isValidDateTime = false,
      tempArray = availibilityArray;

    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let SlotStartDate = new Date(slotInfo.start).toDateString(),
      nowDate = new Date(),
      year = nowDate.getFullYear(), month = nowDate.getMonth(), date = nowDate.getDate(),
      slotStart = new Date(slotInfo.start),
      slotEnd = new Date(slotInfo.end),
      slotStartTime = new Date(year, month, date, slotStart.getHours(), slotStart.getMinutes()),
      slotEndTime = new Date(year, month, date, slotEnd.getHours(), slotEnd.getMinutes()),
      SlotDayName = days[new Date(slotInfo.start).getDay()];

    for (let index = 0;index < tempArray.length;index++) {
      let isValidDay = false;
      if (isDayAvailibility) {
        let availableDayName = tempArray[index].dayName || '';
        isValidDay = (SlotDayName.toLowerCase() === availableDayName.toLowerCase());
      } else {
        let availableDate = new Date(tempArray[index].date).toDateString();
        isValidDay = availableDate === SlotStartDate;
      }
      let availStartTime = new Date(tempArray[index].startTime),
        avialEndTime = new Date(tempArray[index].endTime),
        startTime = new Date(year, month, date, availStartTime.getHours(), availStartTime.getMinutes()),
        endTime = new Date(year, month, date, avialEndTime.getHours(), avialEndTime.getMinutes());

      let isValidTime = (startTime <= slotStartTime && endTime >= slotEndTime);
      let isResourceId = (slotInfo.resourceId ? (slotInfo.resourceId === (tempArray[index].staffID) || '') : true);

      if (isResourceId && isValidDay && (isMonthView || isValidTime)) {
        isValidDateTime = true;
        break;
      }
    }
    return isValidDateTime;
  }

  checkAvailability = (slotInfo) => {
    let isAvailable = false;
    let isUnavailable = false;
    if(this.state.staffsAvailibility==null){
      isAvailable=true;
    }else{
      if (this.state.staffsAvailibility) {
        let availableArray = this.state.staffsAvailibility;
  
        // if(availableArray.overrideAvailabilityWhenSchedulingPermission) { // future requirements
        //   isAvailable = true;
        // }
        // else {
        if (availableArray.unavailable && availableArray.unavailable.length) {
          let isDayAvailibility = false,
            isMonthView = (this.state.currentView || '').toLowerCase() === 'month';
          isUnavailable = this.isAvailableDateTime(availableArray.unavailable, slotInfo, isDayAvailibility, isMonthView);
        }
  
        if (isUnavailable) {
          isAvailable = false;
        } else {
          if (availableArray.available && availableArray.available.length) {
  
            let isDayAvailibility = false,
              isMonthView = (this.state.currentView || '').toLowerCase() === 'month';
            isAvailable = this.isAvailableDateTime(availableArray.available, slotInfo, isDayAvailibility, isMonthView);
          }
  
          if (!isAvailable && availableArray.days && availableArray.days.length) {
            let isDayAvailibility = true,
              isMonthView = (this.state.currentView || '').toLowerCase() === 'month';
            isAvailable = this.isAvailableDateTime(availableArray.days, slotInfo, isDayAvailibility, isMonthView);
          }
        }
       // }
      }
    }
   
    return isAvailable;
  }

  checkClientAvailability = (slotInfo) => {
    this.get_clientAvailability();
    let isAvailable = false;
    let isUnavailable = false;
    
    if (this.state.clientsAvailability == null || this.props.clientsAvailability == undefined) {
      isAvailable = true;
    }else{
      if (this.state.clientsAvailability || this.props.clientsAvailability) {
        let availableArray = this.state.clientsAvailability || this.props.clientsAvailability;
  
        if (availableArray.data.unavailable && availableArray.data.unavailable.length) {
          let isDayAvailibility = false,
            isMonthView = (this.state.currentView || '').toLowerCase() === 'month';
          isUnavailable = this.isAvailableDateTime(availableArray.data.unavailable, slotInfo, isDayAvailibility, isMonthView);
        }
  
        if (isUnavailable) {
          isAvailable = false;
        } else {
          if (availableArray.data.available && availableArray.data.available.length) {
  
            let isDayAvailibility = false,
              isMonthView = (this.state.currentView || '').toLowerCase() === 'month';
            isAvailable = this.isAvailableDateTime(availableArray.data.available, slotInfo, isDayAvailibility, isMonthView);
          }
  
          if (!isAvailable && availableArray.data.days && availableArray.data.days.length) {
            let isDayAvailibility = true,
              isMonthView = (this.state.currentView || '').toLowerCase() === 'month';
            isAvailable = this.isAvailableDateTime(availableArray.data.days, slotInfo, isDayAvailibility, isMonthView);
          }
        }
        // }
      }
    }
   
    return isAvailable;
  }

  checkIsSameOrBefore = (date1, date2) => {
    return moment(date1).isSameOrBefore(date2);  
  }

  checkIsValidAppointment = (appointmentData, requestName) => {
    // check the appointment staffs availablity through api request ...
    let appointment = [{
      'PatientAppointmentId': appointmentData.id,
      'AppointmentTypeID': appointmentData.appointmentTypeID,
      'AppointmentStaffs': appointmentData.appointmentStaffs,
      'PatientID': appointmentData.patientID,
      'LocationId': appointmentData.serviceLocationID,
      'StartDateTime': moment(appointmentData.start).format('YYYY-MM-DD') + 'T' + moment(appointmentData.start).format('HH:mm')+':00',
      'EndDateTime': moment(appointmentData.end).format('YYYY-MM-DD') + 'T' + moment(appointmentData.end).format('HH:mm')+':00',
      'patientInsuranceId': appointmentData.patientInsuranceId || 0
    }];
    // console.log('Check is valid...', JSON.stringify(appointment));
    this.props.checkIsValidAppointment(appointment, requestName);
  }
  checkAuthorizationDetails(appointmentData) {
    let searchObj = {
      'appointmentId': appointmentData.id,
      'patientId': appointmentData.patientID,
      'appointmentTypeId': appointmentData.appointmentTypeID,
      'startDate': moment(appointmentData.start).format('YYYY-MM-DD') + 'T' + moment(appointmentData.start).format('HH:mm')+':00',
      'endDate': moment(appointmentData.end).format('YYYY-MM-DD') + 'T' + moment(appointmentData.end).format('HH:mm')+':00',
      'isAdmin': appointmentData.isAdminUpdateAfterRendered,
      'patientInsuranceId': appointmentData.patientInsuranceId || null,
      'authorizationId': appointmentData.authorizationId || null,
    };
    // console.log('searchObj..', JSON.stringify(searchObj));
    let isUpdateAppointmentRequest = true;
    this.props.getPatientAuthorizationDetails(searchObj, isUpdateAppointmentRequest);
  }

  checkClinicalRoomAvailablity(appointmentData) {
    let searchObj1 = {
      'appointmentId': appointmentData.id,
      // 'appointmentTypeId': appointmentData.appointmentTypeID,      
      // 'appointmentStaffId': appointmentData.appointmentStaffs[0].StaffId,
      // 'patientId': appointmentData.patientID,      
       'locationId': appointmentData.serviceLocationID,
      'startDateTime': moment(appointmentData.start).format('YYYY-MM-DD') + 'T' + moment(appointmentData.start).format('HH:mm')+':00',
      'endDateTime': moment(appointmentData.end).format('YYYY-MM-DD') + 'T' + moment(appointmentData.end).format('HH:mm')+':00',      
      'clinicalRoomId': appointmentData.clinicalRoomId || null,
    };
    // console.log('searchObj..', JSON.stringify(searchObj));
    let isUpdateAppointmentRequest = true;
    this.props.checkClinicalRoomAvailablity(searchObj1, isUpdateAppointmentRequest);
  }

  handleAlertClickForUndoAppointment(event, slotInfo) {
    let requestName = 'undoCancelledAppointment';
    this.checkIsValidAppointment(slotInfo, requestName);
    Alert.closeAll();
  }
  handleUndoCancelAppointment = (slotInfo) => {
    alertConfirmation('Are you sure you want to restore this appointment?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClickForUndoAppointment,
        id: slotInfo,
      },
    });
  }
  closeDialog = () => {
    this.setState({ showDialog: false });
  };

  openDialog = (slotInfo) => {

    // To disable selected slot - use return false on condition.

    if (slotInfo.resourceId) {
      slotInfo.StaffID = slotInfo.resourceId;
    }
    switch ((slotInfo.action || '').toUpperCase()) {
    case 'APPROVE':
      {
        let postData = {
          'id': slotInfo.id,
          'status': 'APPROVED',
        };
        this.props.updatePendingAppointmentStatus(postData);
      } break;
    case 'DELETE':
      {
        if (slotInfo.isRecurrence && !slotInfo.isAppointmentRendered) {
          this.handleRecurrenceDeleteClick(slotInfo);
        } else {
          let data = {
            appointmentId: slotInfo.id,
            parentAppointmentId: null,
            deleteSeries: null,
            claimId: slotInfo.claimId,
          };
          this.handleDeleteClick(null, data);
        }
      } break;
    case 'VIEW_PROFILE':
      {
        if (this.state.patient_id) {
          if (slotInfo.resourceId) {
            // history.push(`/client/profile/${slotInfo.patient_id}`);
          }
        } else {
          if (slotInfo.patientID && this.props.pathClientProfile) {
            let patientId = base64Encode(`${slotInfo.patientID}`);
            let path = `${this.props.pathClientProfile}/${patientId}`;
            history.push(path);
          }
        }
      } break;
    case 'SOAP_NOTE':
      {
        if (slotInfo.soapNoteTitle && slotInfo.soapNoteTitle != 'Auth has expired. Please click edit and update the auth.' && slotInfo.soapNoteTitle != 'Insurance has expired. Please click here to update the client Insurance.') {
          let appointmentId = slotInfo.isRecurrence ? slotInfo.appointmentId ? slotInfo.appointmentId : slotInfo.id : slotInfo.id;
          let isAdminUpdate = ((this.props.modifyAfterRenderPermission) && (slotInfo.claimId && slotInfo.canEdit)) ? 1 : 0;
          let path =''; 
          //path = `${this.props.pathCustomSessionNotes}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
          //history.push(path);
          //console.log('slotInfo...............',slotInfo)
          if(slotInfo.masterNoteTypeKey === "CUSTOM_SESSION_NOTE"){
            if(!slotInfo.isBillable){
              path = `${this.props.pathCustomNonBillableSessionNotes}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
            }else {
              path = `${this.props.pathCustomSessionNotes}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
            }
            history.push(path);
          }
          else if (!slotInfo.isBillable) {
            path = `${this.props.pathNonBillableSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
            history.push(path);
          } else if (slotInfo.isVideoCall) {
            path = `${this.props.pathVideoSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
            history.push({
              pathname: path,
              // state: { master_data: this.props.master_data, appointment: appointment },
            });
          } else {
            if(this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS)
            {      
              if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else {        
                path = `${this.props.pathSessionBehaviorBlossoms}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }
            else if(this.props.agencyName.toUpperCase() === DEMO || this.props.agencyName.toUpperCase() === BUILDABLOCKTHERAPY || this.props.agencyName.toUpperCase() === IAT)
            {
              if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else {        
                path = `${this.props.pathSessionEBS}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }
            else if(this.props.agencyName.toUpperCase().startsWith(EBS))
            {
                if(slotInfo.noteTypeId === 1){
                  path = `${this.props.pathSessionEBS}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } 
                else if(slotInfo.noteTypeId === 2){
                  path = `${this.props.pathSessionEarlyIntervention_EBSPA}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                }
                else if(slotInfo.noteTypeId === 3){
                  path = `${this.props.pathSessionDelawareEI_EBS}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                }
                else if(slotInfo.noteTypeId === 4){
                  path = `${this.props.pathSessionIFSP_DevelopmentTime_EBS}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } 
                else if(slotInfo.noteTypeId === 5){
                  path = `${this.props.pathSessionIllinois_Evaluation_EBS}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } 
                else if(slotInfo.noteTypeId === 6){
                  path = `${this.props.pathSessionIllinois_EBS}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                }  else if(slotInfo.noteTypeId === 101){          
                  path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } else if(slotInfo.noteTypeId === 102){          
                  path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                }
            }
            else if(this.props.agencyName.toUpperCase() === CBG)
            {
                if(slotInfo.noteTypeId === 1){
                  path = `${this.props.pathSessionCBG}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                }
                else if(slotInfo.noteTypeId === 2){
                  path = `${this.props.pathProgressNote_One}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } else if(slotInfo.noteTypeId === 101){          
                  path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } else if(slotInfo.noteTypeId === 102){          
                  path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                }
            }
            else if(this.props.agencyName.toUpperCase() === AIP)
            {
              if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else {        
                path = `${this.props.pathSessionAIP}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }
            else if(this.props.agencyName.toUpperCase() === NE_ABA)
            {
              if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else {        
                path = `${this.props.pathSessionNE_ABA}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }
            else if(this.props.agencyName.toUpperCase() === POSITIVEBEHAVIORSTEPS)
            {
              if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else {        
                path = `${this.props.pathSession_PBS}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }            
            else if(this.props.agencyName.toUpperCase() === BESTABA)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSession_BT_BESTABA}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
              else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathSession_BCBA_BESTABA}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }    
            else if(this.props.agencyName.toUpperCase() === SWANCONSULTINGINC)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
              else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathSession_PSYCHOLOGICAL_SWAN}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }  
            else if(this.props.agencyName.toUpperCase() === CAS)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
              else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathProgressNote_One}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            } 
            else if(this.props.agencyName.toUpperCase() === VICTORIOUSLEARNING)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
              else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathProgressNote_One}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }
            else if(this.props.agencyName.toUpperCase() === ABAORLANDO)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathSessionNoteABAOR_RBT}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 3){
                path = `${this.props.pathSessionNoteABAOR_BCBA}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }
            else if(this.props.agencyName.toUpperCase() === SOAR)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathSession_AssessmentNote_SOAR}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 3){
                path = `${this.props.pathSession_DirectTherapyNote_SOAR}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 4){
                path = `${this.props.pathSession_BCBASupervisionNote_SOAR}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 5){
                path = `${this.props.pathSession_FamilyTreatmentNote_SOAR}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 6){
                path = `${this.props.pathSession_DiagnosticEvaluation_SOAR}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } 
            }
            else if(this.props.agencyName.toUpperCase() === HYPERIONCENTER)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathSession_Hyperion}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } 
            }   
            else if(this.props.agencyName.toUpperCase() === HELPINGHANDS)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathSessionSupervision_HIH}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } 
            }
            else if(this.props.agencyName.toUpperCase() === FUTURES)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathSessionPsychEval_FUTURES}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 3){
                path = `${this.props.pathSessionSLPEval_FUTURES}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } 
            }      
            else if(this.props.agencyName.toUpperCase() === TFABA)
            {
              if(slotInfo.noteTypeId === 1){
                path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 2){
                path = `${this.props.pathSession_RBT_TFABA}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 3){
                path = `${this.props.pathSession_BCBA_TFABA}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 101){          
                path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              } else if(slotInfo.noteTypeId === 102){          
                path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
              }
            }        
            else
            {
                if(slotInfo.noteTypeId === 1){
                  path = `${this.props.pathSoap}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } else if(slotInfo.noteTypeId === 101){          
                  path = `${this.props.pathSessionNotes_BT_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } else if(slotInfo.noteTypeId === 102){          
                  path = `${this.props.pathSessionNotes_BCBA_Default}/${appointmentId}/${slotInfo.PatientEncounterId}/${isAdminUpdate}/0`;
                } 
            }
            history.push({
              pathname: path,
              // state: { master_data: this.props.master_data, appointment: appointment },
            });
          }
        }
        else if(slotInfo.soapNoteTitle === 'Insurance has expired. Please click here to update the client Insurance.') {
          let patientId = base64Encode(`${slotInfo.patientID}`);
          //history.push('/client/' + `${patientId}` + '/1');
          history.push('/client/' + `${patientId}?tab=4`);
        }
      } break;
    case 'CANCEL':
      {
        Alert.closeAll();
        this.setState({ showCancelAppointmentDialog: true, slotInfo: slotInfo });
        // this.loadModalData(slotInfo);
      } break;
    case 'UNCANCEL':
      {
        Alert.closeAll();
        this.handleUndoCancelAppointment(slotInfo);
        // this.checkIsValidAppointment(slotInfo);
        // this.props.undoCancelledAppointment(slotInfo.id);
      } break;
    case 'EDIT':
      {
        if( !this.state.isShowInActiveStaffActive && !this.state.isShowInActivePatientsActive){
          Alert.closeAll();
          this.loadAppointmentModalData(slotInfo);
          this.setState({ showDialog: true, slotInfo: slotInfo });
        }
      } break;
    default:
      {
        let isInActiveUser = this._isShouldAllowCreateAppoinment();
        if(!isInActiveUser){
        if (this.props.addPermission) {
          if (this.state.currentView === 'month') {
            slotInfo.end = new Date(moment(slotInfo.end).set('hour', 12));
            slotInfo.start = new Date(moment(slotInfo.start).set('hour', 12));
          }
          // let isAvailable = !(this.state.patient_id) ? this.props.overrideAvailabilityWhenScheduling === false || this.props.overrideClientAvailabilityWhenScheduling === false  ? this.checkAvailability(slotInfo) : true : true;
            let isAvailable = true;


            if (this.props.overrideAvailabilityWhenScheduling && this.props.overrideClientAvailabilityWhenScheduling) {

              isAvailable = true;
            }

            else if (this.props.overrideAvailabilityWhenScheduling && !this.props.overrideClientAvailabilityWhenScheduling) {

              isAvailable =  this.state.selectedPatient.length ? this.checkClientAvailability(slotInfo) : true;
            }

            else if (!this.props.overrideAvailabilityWhenScheduling && this.props.overrideClientAvailabilityWhenScheduling) {

              isAvailable =this.state.selectedStaff.length ?  this.checkAvailability(slotInfo) :true;
              // let staffAvailable = this.state.selectedStaff.length ?  this.checkAvailability(slotInfo) :true;
              // let clientAvailable = this.state.selectedPatient.length ? this.checkClientAvailability(slotInfo) : true;
              // isAvailable = staffAvailable || clientAvailable;
            }

            else if (!this.props.overrideAvailabilityWhenScheduling && !this.props.overrideClientAvailabilityWhenScheduling) {

              let staffAvailable = this.state.selectedStaff.length ?  this.checkAvailability(slotInfo) :true;
              let clientAvailable = this.state.selectedPatient.length ? this.checkClientAvailability(slotInfo) : true;
              isAvailable = staffAvailable && clientAvailable;
            }

            if (isAvailable) {
              if (this.state.lock_scheduler != null && this.checkIsSameOrBefore(moment(slotInfo.end).format('YYYY/MM/DD'), moment(this.state.lock_scheduler).format('YYYY/MM/DD'))) {
                Alert.closeAll();
                showErrorMessage('Your schedule has been locked until ' + moment(this.state.lock_scheduler).format('MM-DD-YYYY') + ' . You are unable to schedule appointments on or before this date. Please contact your scheduler.');
              } else {
                Alert.closeAll();
                this.loadAppointmentModalData(slotInfo);
                this.setState({ showDialog: true, slotInfo: slotInfo });
              }
            } else {
              Alert.closeAll();
              showWarningMessage('Selected staff(s) or client is not available at this date, time.');
            }
          }
        } else {
          showWarningMessage("You can't create an Appointment for Inactive client/staff");
        }
      }
    }

    // if (slotInfo.action === 'delete') {

    // } else if (slotInfo.action === 'view_profile') {

    // } else if (slotInfo.action === 'soap_note') {

    // } else if (slotInfo.action === 'cancel') {

    // } else if (slotInfo.action === 'uncancel') {

    // } else if (slotInfo.action === 'edit') {

    // } else { // alert('here'); // add return false here is staff has not assigned a time slot

    // }
  }


  loadAppointmentModalData(slotInfo) {
    let masterData = {
      'masterdata': 'MASTERPATIENTLOCATION,MODEOFMEETING,SUPERVISIONTYPE,PAYRATETYPE,MASTERCLINICALROOM',
    };
    this.props.getMasterData(masterData);
  }

  // loadModalData(slotInfo) {
  //   let masterData = {
  //     'masterdata': 'MASTERCANCELTYPE',
  //   };
  //   this.props.getMasterData(masterData);
  // }

  openCancelAppointmentDialog() {
    this.setState({ showCancelAppointmentDialog: true });
  }

  closeCancelAppointmentDialog() {
    this.setState({ showCancelAppointmentDialog: false, slotInfo: null });
  }

  handleRecurrenceDeleteClick = (appointment) => {
    let alertConfig = {
      customButtons: [{
        name: 'Delete Series',
        handleClick: this.handleDeleteClick,
        param: {
          appointmentId: appointment.id,
          parentAppointmentId: appointment.parentAppointmentId,
          deleteSeries: true,
          claimId: appointment.claimId,
        },
      }, {
        name: 'Delete One',
        handleClick: this.handleDeleteClick,
        param: {
          appointmentId: appointment.id,
          parentAppointmentId: appointment.parentAppointmentId,
          deleteSeries: false,
          claimId: appointment.claimId,
        },
      }],
    };
    alertConfirmation('Do you want to delete whole series or this one?', alertConfig);
  };

  handleAlertClick = (event, appointment) => {
    let isAdminDeleteAfterRender = appointment.claimId ? true : false;
    this.props.deleteAppointmentData(appointment.appointmentId, appointment.parentAppointmentId, appointment.deleteSeries, isAdminDeleteAfterRender);
  }

  handleDeleteClick = (e, appointmentData) => {
    alertConfirmation((this.props.agencyName.toUpperCase() === JOYSCAPE ? 'Do not delete client cancellations — please mark as cancelled. Are you sure you want to delete appointment(s)?' : 'Are you sure you want to delete appointment(s)?'), {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: appointmentData,
      },
    });
  };

  deselectAll = (type) => { //  Uncheck All Staff/Patient
    if (type === 'Location') {
      let selectedLocations = [];
      this.props.dispatch(change('scheduleForm', 'Location', selectedLocations));
      this.props.dispatch(change('scheduleForm', 'Patient', []));
      this.props.dispatch(change('scheduleForm', 'Staffs', []));
      this.props.dispatch(change('scheduleForm', 'Activity', []));
      this.props.dispatch(change('scheduleForm', 'ClinicalRoom', []));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ isShowInActivePatientsActive:false,isShowInActiveStaffActive:false,IsDisplayNumberOfHours: false, allLocation: [], selectedLocation: [], selectedPatient: [], selectedStaff: [], selectedActivity: [], staffsAvailibility: null }, () => {
        this.setState({ staffActiveTab: '', selectAllStaff: false, deSelectAllStaff: false, tagStaff: false });
        this.setState({ clientActiveTab: '', selectAllPatient: false, deSelectAllPatient: false, tagClient: false });
        this.setState({ activityActiveTab: '', selectAllActivity: false, deSelectAllActivity: false });
        this.setState({ clinicalRoomActiveTab: '', selectAllClinicalRoom: false, deSelectAllClinicalRoom: false });
        this.setState({ lock_scheduler: this.state.lockSchedulerDateAppConfig, locationActiveTab: 'deselectAll', allLocation: [{ deselectAll: true }, ...this.props.userLocationList], deSelectAllLocation: true, selectAllLocation: false, selectedLocation: [] }, () => this.get_all_appointments());
      });
      // assign no staffs to the staff view in scheduler
      this.setState({ resource_list: [{ id: 0, title: 'No Staff Selected' }] });
      this.getOnlyInActiveStaffsAndPatientsList('');
      this.getStaffsAndPatientsList('');
    }
    if (!(this.state.selectedLocation && this.state.selectedLocation.length)) {
      return false;
    }
    if (type === 'Staff') {
      let selectedstaffs = [];
      this.props.dispatch(change('scheduleForm', 'Staffs', selectedstaffs));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({  
        // isShowInActiveStaffActive:false,
        IsDisplayNumberOfHours: false, allStaff: [], selectedStaff: [], tagStaff: false, selectedStaffTags: [] }, () => {
        this.setState({ lock_scheduler: this.state.lockSchedulerDateAppConfig, staffActiveTab: 'deselectAll', allStaff: [{ deselectAll: true }, ...this.props.staffs], deSelectAllStaff: true, selectAllStaff: false, selectedStaff: [] }, () => {
          this.get_staffsAvailability();
          this.get_all_appointments();
          // this.props.updateSelectedSchedulerData(this.state.selectedStaff, 'staff');
        });
      });
      // assign no staffs to the staff view in scheduler
      this.setState({ resource_list: [{ id: 0, title: 'No Staff Selected' }] });
    }
    if (type === 'Client') {
      let selectedPatients = [];
      this.props.dispatch(change('scheduleForm', 'Patient', selectedPatients));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({
        // isShowInActivePatientsActive:false,
        IsDisplayNumberOfHours: false, allPatient: [], selectedPatient: [], tagClient: false, selectedClientTags: [] }, () => {
        this.setState({ clientActiveTab: 'deselectAll', allPatient: [{ deselectAll: true }, ...this.props.patientList], deSelectAllPatient: true, selectAllPatient: false, selectedPatient: [] }, () => this.get_all_appointments());
      });
    }
    if (type === 'Activity') {
      let selectedActivities = [];
      this.props.dispatch(change('scheduleForm', 'Activity', selectedActivities));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, allActivity: [], selectedActivity: [] }, () => {
        this.setState({ activityActiveTab: 'deselectAll', allActivity: [{ deselectAll: true }, ...this.props.activityList], deSelectAllActivity: true, selectAllActivity: false, selectedActivity: [] }, () => this.get_all_appointments());
      });
    }

    if (type === 'ClinicalRoom') {
      let selectedClinicalRooms = [];
      this.props.dispatch(change('scheduleForm', 'ClinicalRoom', selectedClinicalRooms));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, allClinicalRoom: [], selectedClinicalRoom: [] }, () => {
        this.setState({ clinicalRoomActiveTab: 'deselectAll', allClinicalRoom: [{ deselectAll: true }, ...this.props.clinicalRoomList], deSelectAllClinicalRoom: true, selectAllClinicalRoom: false, selectedClinicalRoom: [] }, () => this.get_all_appointments());
      });
    }
  };

  selectAll = (type) => { //  Check All Staff/Patient

    let selectedLocations = this.props.userLocationList.map((obj) => obj.id);
    if (type === 'Location') {
      this.props.dispatch(change('scheduleForm', 'Location', selectedLocations));
      this.props.dispatch(change('scheduleForm', 'Patient', []));
      this.props.dispatch(change('scheduleForm', 'Staffs', []));
      this.props.dispatch(change('scheduleForm', 'Activity', []));
      this.props.dispatch(change('scheduleForm', 'ClinicalRoom', []));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ isShowInActivePatientsActive:false,isShowInActiveStaffActive:false, IsDisplayNumberOfHours: false, allLocation: [], selectedLocation: [], selectedPatient: [], selectedStaff: [], selectedActivity: [], staffsAvailibility: null }, () => {
        this.setState({ staffActiveTab: '', selectAllStaff: false, deSelectAllStaff: false, tagStaff: false });
        this.setState({ clientActiveTab: '', selectAllPatient: false, deSelectAllPatient: false, tagClient: false });
        this.setState({ activityActiveTab: '', selectAllActivity: false, deSelectAllActivity: false });
        this.setState({ clinicalRoomActiveTab: '', selectAllClinicalRoom: false, deSelectAllClinicalRoom: false });
        this.setState({ lock_scheduler: this.state.lockSchedulerDateAppConfig, locationActiveTab: 'selectAll', allLocation: this.props.userLocationList, selectAllLocation: true, deSelectAllLocation: false, selectedLocation: selectedLocations }, () => {
          let searchTermLocation = (selectedLocations || []).join(',');
          this.props.getOfficeHours(searchTermLocation);
          this.getOnlyInActiveStaffsAndPatientsList(searchTermLocation);
          this.getStaffsAndPatientsList(searchTermLocation);
          this.get_all_appointments();
        });
      });
    }
    if (!(this.state.selectedLocation && this.state.selectedLocation.length)) {
      return false;
    }
    if (type === 'Staff') {
      // assign all staffs to the staff view in scheduler

      let selectedstaffs = this.props.staffs.map((obj) => obj.id);
      this.props.dispatch(change('scheduleForm', 'Staffs', selectedstaffs));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      let staff_data = [];
      if (this.props.staffs && this.props.staffs.length) {
        this.props.staffs.forEach((staff, index) => {
          staff_data.push({
            id: staff.id,
            title: staff.value,
          });
        });
        this.setState({ resource_list: staff_data });
      }
      this.setState({ IsDisplayNumberOfHours: false, allStaff: [], selectedStaff: [], tagStaff: false, selectedStaffTags: [] }, () => {
        this.setState({ lock_scheduler: this.state.lockSchedulerDateAppConfig, staffActiveTab: 'selectAll', allStaff: this.props.staffs, selectAllStaff: true, deSelectAllStaff: false, selectedStaff: selectedstaffs }, () => {
          this.get_staffsAvailability();
          this.get_all_appointments();
          // this.props.updateSelectedSchedulerData(this.state.selectedStaff, 'staff');
        });
      });
    }
    if (type === 'Client') {
      let selectedPatients = this.props.patientList.map((obj) => obj.id);
      this.props.dispatch(change('scheduleForm', 'Patient', selectedPatients));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, allPatient: [], selectedPatient: [], tagClient: false, selectedClientTags: [] }, () => {
        this.setState({ clientActiveTab: 'selectAll', allPatient: this.props.patientList, selectAllPatient: true, deSelectAllPatient: false, selectedPatient: selectedPatients }, () => this.get_all_appointments());
      });
    }
    if (type === 'Activity') {
      let selectedActivities = this.props.activityList.map((obj) => obj.id);
      this.props.dispatch(change('scheduleForm', 'Activity', selectedActivities));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, allActivity: [], selectedActivity: [] }, () => {
        this.setState({ activityActiveTab: 'selectAll', allActivity: this.props.activityList, selectAllActivity: true, deSelectAllActivity: false, selectedActivity: selectedActivities }, () => this.get_all_appointments());
      });
    }
    if (type === 'ClinicalRoom') {
      let selectedClinicalRooms = this.props.clinicalRoomList.map((obj) => obj.id);
      this.props.dispatch(change('scheduleForm', 'ClinicalRoom', selectedClinicalRooms));
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, allClinicalRoom: [], selectedClinicalRoom: [] }, () => {
        this.setState({ clinicalRoomActiveTab: 'selectAll', allClinicalRoom: this.props.clinicalRoomList, selectAllClinicalRoom: true, deSelectAllClinicalRoom: false, selectedClinicalRoom: selectedClinicalRooms }, () => this.get_all_appointments());
      });
    }
  };

  tagSelection = (type) => { // Search appointment by tag for staff and client
    if (!(this.state.selectedLocation && this.state.selectedLocation.length)) {
      return false;
    }
    if (type === 'StaffTags') {
      this.setState({ tagStaff: true }, () => {
        this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
        this.setState({  
          // isShowInActiveStaffActive:false,
          lock_scheduler: this.state.lockSchedulerDateAppConfig,
          IsDisplayNumberOfHours: false,
          staffActiveTab: 'tag',
          selectAllStaff: false,
          deSelectAllStaff: false 
        });
      });
    }
    if (type === 'ClientTags') {
      this.setState({ tagClient: true }, () => {
        this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
        this.setState({
          // isShowInActivePatientsActive:false,
          IsDisplayNumberOfHours: false,
          clientActiveTab: 'tag',
          selectAllPatient: false,
          deSelectAllPatient: false 
        });
      });
    }
  }

  showInActiveSelection = (type) => {
    let selectedLocation = this.state.selectedLocation.join(',');

    if (!(this.state.selectedLocation && this.state.selectedLocation.length)) {
      return false;
    }
    if (type === 'Staff') {
      let selectedstaffs = [];
        this.props.dispatch(change('scheduleForm', 'Staffs', selectedstaffs));
        this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
        if(!this.state.isShowInActiveStaffActive){
          let staffFlag = "INACTIVEONLY";
          let patientsFlag= this.state.isShowInActivePatientsActive ? "INACTIVEONLY" : "ACTIVEONLY"; 
          this.setState({
            isShowInActiveStaffActive:true,
            IsDisplayNumberOfHours: false,
            tagStaff: false,
            staffActiveTab: 'inactive',
            deSelectAllStaff: false, 
            selectAllStaff: false,
            allStaff: [],
            selectedStaff: [],
            selectedStaffTags: [],
          },()=>{
            this.getOnlyInActiveStaffsAndPatientsList(selectedLocation);
            this.getStaffsAndPatientsList(selectedLocation,undefined,staffFlag,patientsFlag);
            this.get_patient_appointments();
          })
        }else{
          let staffFlag = "ACTIVEONLY";
          let patientsFlag= this.state.isShowInActivePatientsActive ? "INACTIVEONLY" : "ACTIVEONLY"; 

          this.setState({
            IsDisplayNumberOfHours:false,
            isShowInActiveStaffActive:false,
            tagStaff: false,
            staffActiveTab: 'inactive',
            deSelectAllStaff: false, 
            selectAllStaff: false,
            allStaff: [],
            selectedStaff: [],
            selectedStaffTags: [] },()=>{
            this.getOnlyInActiveStaffsAndPatientsList(this.state.selectedLocation);
            this.getStaffsAndPatientsList(this.state.selectedLocation,undefined,staffFlag,patientsFlag);
            this.get_patient_appointments();
          });
        }
        
    }
    if (type === 'Client') {
      let selectedPatients = [];
        this.props.dispatch(change('scheduleForm', 'Patient', selectedPatients));
        this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));

        if(!this.state.isShowInActivePatientsActive){
          
          let patientsFlag = "INACTIVEONLY";
          let staffFlag = this.state.isShowInActiveStaffActive ? "INACTIVEONLY" : "ACTIVEONLY"; 

          this.setState({
            isShowInActivePatientsActive:true,
            IsDisplayNumberOfHours: false,
            tagClient: false,
            clientActiveTab: 'inactive',
            deSelectAllPatient: false, 
            selectAllPatient: false,
            allPatient: [],
            selectedPatient: [],
            selectedClientTags: [],
          },()=>{
            this.getOnlyInActiveStaffsAndPatientsList(selectedLocation);
            this.getStaffsAndPatientsList(selectedLocation,undefined,staffFlag,patientsFlag);
            this.get_patient_appointments();
          })
        }else{
          let patientsFlag = "ACTIVEONLY";
          let staffFlag = this.state.isShowInActiveStaffActive ? "INACTIVEONLY" : "ACTIVEONLY";
          this.setState({
            IsDisplayNumberOfHours: false,
            isShowInActivePatientsActive:false,
            tagClient: false,
            clientActiveTab: 'inactive',
            deSelectAllPatient: false, 
            selectAllPatient: false,
            allPatient: [],
            selectedPatient: [],
            selectedClientTags: []
          }, () => {
            this.getOnlyInActiveStaffsAndPatientsList(this.state.selectedLocation);
            this.getStaffsAndPatientsList(this.state.selectedLocation,undefined,staffFlag,patientsFlag);
            this.get_patient_appointments();
          })
        }
    }
  }

  handleDisplayNumberOfHours = (input) => {
    this.setState({ IsDisplayNumberOfHours: input.target.checked }, ()=>{this.get_all_appointments();});
  }

  handleChange=(input, value, searchData, label, selectedData) => {
    let staff_data = [];
    if (label === 'Staff') {
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, selectAllStaff: false, deSelectAllStaff: false });

      this.setState({ selectedStaffTags: [], selectedStaff: value }, () => {
        this.get_staffsAvailability();
        this.get_all_appointments();
        // this.props.updateSelectedSchedulerData(this.state.selectedStaff, 'staff');
      });
      if ((searchData !== null) && !value.length) { //  Async Api Call
        var values = [];
        if (this.state.resource_list.length && (this.state.resource_list[0].id !== 0)) {
          this.state.resource_list.forEach((allValues, i) => {
            values.push(allValues.id);
          });
          this.props.staffs.forEach((staff, index) => {
            if (values.includes(staff.id)) {
              staff_data.push({
                id: staff.id,
                title: staff.value,
              });
            }
          });
          this.setState({ resource_list: staff_data });
        } else {
          this.setState({ resource_list: [{ id: 0, title: 'No Staff Selected' }] });
        }
      } else { //  No api Call.
        if (value && value.length) {
          this.props.staffs.forEach((staff, index) => {
            if (value.includes(staff.id)) {
              staff_data.push({
                id: staff.id,
                title: staff.value,
              });
            }
          });
          this.setState({ resource_list: staff_data });
        } else {
          this.setState({ resource_list: [{ id: 0, title: 'No Staff Selected' }] });
        }
      }
    }


    if (label === 'Client') { // For Patient
      /* if (searchData !== '') {
        this.props.getPatients('startwith', `${searchData}`, null);
      }*/
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, selectAllPatient: false, deSelectAllPatient: false });
      this.setState({ selectedClientTags: [], selectedPatient: value }, () => {
        this.get_all_appointments();
        this.get_clientAvailability();
      });
    }

    if (label === 'Activity') { // For Activity
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, selectAllActivity: false, deSelectAllActivity: false });
      this.setState({ selectedActivity: value }, () => this.get_all_appointments());
    }
    if (label === 'Therapy Room') { // For Therapy Room
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ IsDisplayNumberOfHours: false, selectAllClinicalRoom: false, deSelectAllClinicalRoom: false });
      this.setState({ selectedClinicalRoom: value }, () => this.get_all_appointments());
    }
    if (label === 'Location') { // For Location
      let searchTermLocation = '';
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      this.setState({ isShowInActivePatientsActive:false,isShowInActiveStaffActive:false,IsDisplayNumberOfHours: false, selectAllLocation: false, deSelectAllLocation: false });
      searchTermLocation = (value || []).join(',');
      if (searchTermLocation) {
        this.props.getOfficeHours(searchTermLocation);
      }
      this.getOnlyInActiveStaffsAndPatientsList(searchTermLocation);
      this.getStaffsAndPatientsList(searchTermLocation);
      this.setState({ staffActiveTab: '', selectAllStaff: false, deSelectAllStaff: false, tagStaff: false });
      this.setState({ clientActiveTab: '', selectAllPatient: false, deSelectAllPatient: false, tagClient: false });
      this.setState({ activityActiveTab: '', selectAllActivity: false, deSelectAllActivity: false });
      this.setState({ clinicalRoomActiveTab: '', selectAllClinicalRoom: false, deSelectAllClinicalRoom: false });
      this.setState({ staffsAvailibility: null });
      this.props.dispatch(change('scheduleForm', 'Patient', []));
      this.props.dispatch(change('scheduleForm', 'Staffs', []));
      this.props.dispatch(change('scheduleForm', 'Activity', []));
      this.props.dispatch(change('scheduleForm', 'ClinicalRoom', []));
      this.setState({ selectedLocation: value || [], selectedPatient: [], selectedStaff: [], selectedActivity: [], selectedClinicalRoom: []  }, () => {
        this.setState({ resource_list: [{ id: 0, title: 'No Staff Selected' }] });
        this.get_all_appointments();
      });
    }
    if (label === 'Staff Tags') {

      let staffTags = [];
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      if (selectedData.length) {
        selectedData.forEach((selectedData, i) => {
          staffTags.push(selectedData.value);          
        });

        if(staffTags.length > 0)
        {
          let searchObj1 = { contain_filters: { Tags: staffTags }, showInactiveUsersOnly: this.state.isShowInActiveStaffActive ? "INACTIVEONLY" : "ACTIVEONLY"};
          // console.log("scheduler searchObj", searchObj1);
          this.props.getStaffByTags(searchObj1);        
        }
      }
      else{
        this.setState({ IsDisplayNumberOfHours: false, selectedStaffTags: [], selectedStaff: [], resource_list: [{ id: 0, title: 'No Staff Selected' }] }, () =>{ 
          this.get_staffsAvailability();
          this.get_all_appointments()
        });
      }
    }
    if (label === 'Client Tags') {

      let clientTags = [];
      this.props.dispatch(change('scheduleForm', 'IsDisplayNumberOfHours', false));
      if (selectedData.length) {
        selectedData.forEach((selectedData, i) => {
          clientTags.push(selectedData.value);          
        });

        if(clientTags.length > 0)
        {
          let searchObj1 = { contain_filters: { Tags: clientTags }, showInactiveUsersOnly: this.state.isShowInActivePatientsActive ? "INACTIVEONLY" : "ACTIVEONLY"};
          // console.log("scheduler searchObj", searchObj1);
          this.props.getClientByTags(searchObj1);        
        }
      }else{
        this.setState({ IsDisplayNumberOfHours: false, selectedPatient: [], selectedClientTags: selectedData }, () => this.get_all_appointments());
      }

    }
  };

  handleStaffView(view) {
    this.setState({
      currentView: view,
    }, () => {
    if (this.state.currentView === 'month') {
      this.setState((prevState, props) => {
        let appointments = prevState.appointments.map((Obj) => {
          Obj.title = Obj.appointmentTime + '\n' + Obj.title;
          return Obj;
        });
        return { appointments: appointments };
      });
    } else {
      this.setState((prevState, props) => {
        let appointments = prevState.appointments.map((Obj) => {
          Obj.title = Obj.title.replace(Obj.appointmentTime, '');
          return Obj;
        });
        return { appointments: appointments };
      });
    }
    if (view === 'resource') {
      this.setState({ IsStaffView: true });
    } else {
      this.setState({ IsStaffView: false });
    }

    let month = moment(this.state.schedulerDate).get('month');
    this.renderMonthNavigation(month, this.state.schedulerDate);
  })
  }

  eventStyleGetter(event, date, end, isSelected) { // , start, end, isSelected
    // console.log('event, date, end, isSelected...', event, date, end, isSelected);
    let borderColor = event.appointmentBackgroundColor;
    if ((event.statusName || '').toLowerCase() === 'pending') {
      borderColor = 'rgb(236, 216, 51)';
    // } else if ((event.statusName || '').toLowerCase() === 'approved') {
    //   borderColor = 'green';
    // } else if ((event.statusName || '').toLowerCase() === 'cancel') {
    //   borderColor = 'red';
    }
    let style = {
      backgroundColor: event.appointmentBackgroundColor,
      color: event.appointmentFontColor,
      '-webkit-user-drag': 'none'
      // border: 'none',
      // borderLeft: `10px solid ${borderColor}`,
    };
    return {
      style: style,
    };
  }

  onSchedulerDateChange(value) {
    // input.onChange(moment(value).format('YYYY-MM-DD'));
    let month = moment(value).get('month');
    if (value !== this.state.schedulerDate) {
      this.setState({ schedulerDate: value }, () => this.renderMonthNavigation(month, value));
    }
  }

  onNavigateMonth(date) {
    let month = moment(date).get('month');
    if (date !== this.state.schedulerDate) {
      this.setState({ schedulerDate: date }, () => this.renderMonthNavigation(month, date));
    }
  }

  renderMonthNavigation(month, date) {
    this.setFilteredDateObject(date);
    if (this.state.patient_id) {
      this.get_patient_appointments();
    } else {
      this.get_staffsAvailability();
      this.get_all_appointments();
    }
  }

  openDatePicker() {
    this.refs.dp.openDialog();
  }

  handleMoveAppointmentClick(e, appointment) {
    let isAdminUpdateAfterRendered = appointment.claimId ? true : false;
    let appointmentData = {
      ...appointment,
      isAdminUpdateAfterRendered,
    };
    this.setState({ isCheckedValidate: false });
    let requestName = 'updateAppointment';
    this.checkIsValidAppointment(appointmentData, requestName);
    if (appointmentData.isBillable) {
      this.setState({ isCheckedAuthorization: false });
      this.checkAuthorizationDetails(appointmentData);
      if(appointmentData.clinicalRoomId) {
        this.checkClinicalRoomAvailablity(appointmentData);  
      }    
    } else {
      this.setState({ isCheckedAuthorization: true });
    }

    let updateAppointmentData = [{
      'PatientAppointmentId': appointmentData.id,
      'PatientEncounterId': appointment.PatientEncounterId ? appointment.PatientEncounterId : 0,
      'AppointmentTypeID': appointmentData.appointmentTypeID,
      'AppointmentStaffs': appointmentData.appointmentStaffs,
      'PatientID': appointmentData.patientID,
      'ServiceLocationID': appointmentData.serviceLocationID,
      'OfficeAddressID': appointmentData.officeAddressID,
      'PatientAddressID': appointmentData.patientAddressID,
      'CustomAddressID': appointmentData.customAddressID,
      'CustomAddress': appointmentData.customAddress,
      'latitude': appointmentData.latitude,
      'longitude': appointmentData.longitude,
      'StartDateTime': moment(appointmentData.start).format('YYYY-MM-DD') + 'T' + moment(appointmentData.start).format('HH:mm')+':00',
      'EndDateTime': moment(appointmentData.end).format('YYYY-MM-DD') + 'T' + moment(appointmentData.end).format('HH:mm')+':00',
      'Notes': appointmentData.notes,
      'IsTelehealthAppointment': appointmentData.isTelehealthAppointment,
      'IsRecurrence': appointmentData.isRecurrence,
      'RecurrenceRule': appointmentData.recurrenceRule,
      'IsClientRequired': appointmentData.isClientRequired,
      'IsBillable': appointmentData.isBillable,
      'IsBillableAppointment': appointmentData.isBillable,
      'noteTypeId': appointmentData.noteTypeId,
      'Offset': moment().utcOffset(),
      'Timezone': calculateTimeZone(),
      'IsExcludedFromMileage': appointmentData.isExcludedFromMileage,
      'IsDirectService': appointmentData.isDirectService,
      'Mileage': appointmentData.mileage,
      'DriveTime': appointmentData.driveTime,
      'IsExcludedFromPayroll': appointmentData.isExcludedFromPayroll,
      'IsClientCheckedIn': appointmentData.isClientCheckedIn,
      'PatientInsuranceId': appointment.patientInsuranceId,
      'AuthorizationId': appointment.authorizationId,
      'claimId': appointmentData.claimId,
      'canEdit': appointmentData.canEdit,
      'serviceAddress': appointmentData.serviceAddress,
      'IsMakeUpSession': appointmentData.isMakeUpSession,
      'BatchParentAppointmentId': appointmentData.batchParentAppointmentId,
      'IsRBTTracking': appointmentData.isRBTTracking,
    }];
    this.setState({ updateAppointmentData });
    this.setState({patientInsuranceId:appointmentData.patientInsuranceId})
  }

  moveAppointment({ event, start, end }) {
    if(this._isShouldAllowCreateAppoinment()){
      showErrorMessage("Appointments for inactive client/staff cannot be modified");
      return;
    }

    const appointment = { ...event, start, end };

    let alertConfig = {
      customButtons: [{
        name: 'Move',
        handleClick: this.handleMoveAppointmentClick,
        param: appointment,
      }, {
        name: 'Cancel',
        handleClick: () => Alert.closeAll(),
        param: null,
      }],
    };
    let movedDate = moment(start).format('MM/DD/YYYY'),
      movedStartTime = moment(start).format('h:mm a'),
      movedEndTime = moment(end).format('h:mm a');
      let sessionDate  = moment(event.start).format('MM/DD/YYYY');
      // var ms = moment(start,"MM/DD/YYYY HH:mm:ss").isBefore(moment(end,"MM/DD/YYYY HH:mm:ss"));      
       
      // console.log('event........',event)
      // console.log('compare........',moment(movedDate,"MM/DD/YYYY").isAfter(moment(new Date(),"MM/DD/YYYY")))
      // console.log('moment(movedDate,"MM/DD/YYYY")........',moment(movedDate,"MM/DD/YYYY"))
      // console.log('moment(new Date(),"MM/DD/YYYY")........',moment(new Date(),"MM/DD/YYYY"))
       
      if(this.props.editAppointmentTimeOnlyPermission === true && !moment(movedDate,"MM/DD/YYYY").isSame(moment(sessionDate,"MM/DD/YYYY"))) 
      {
        showErrorMessage('Your user role does not have permissions to change the session date.');
      }
      else if(this.props.editAppointmentTimeOnlyPermission === false && event.claimId > 0 && moment(movedDate,"MM/DD/YYYY").isAfter(moment(new Date(),"MM/DD/YYYY"))) 
      {
        showErrorMessage('Moving a completed session to a future date of service is not allowed.');
      }
      else
      {
        if(this.state.lock_scheduler != null && this.checkIsSameOrBefore(moment(movedDate).format('YYYY/MM/DD'), moment(this.state.lock_scheduler).format('YYYY/MM/DD'))) {            
          Alert.closeAll();
          showErrorMessage('Your schedule has been locked until ' + moment(this.state.lock_scheduler).format('MM-DD-YYYY') + ' . You are unable to schedule appointments on or before this date. Please contact your scheduler.');
        }
        else {
          if((moment(start).format('MM/DD/YYYY') === moment(end).format('MM/DD/YYYY')) && moment(start,"MM/DD/YYYY HH:mm:ss").isBefore(moment(end,"MM/DD/YYYY HH:mm:ss")))
          {
            //alertConfirmation(`Appointment will be moved to ${movedDate} from ${movedStartTime} - ${movedEndTime}.`, alertConfig);
            alertConfirmation(`Appointment will be moved to ${movedDate} from ${movedStartTime} - ${movedEndTime}.`, alertConfig);
          }
          else
          {      
            showErrorMessage('Appointment time is invalid');
          }
        }
      }
  }

  resizeAppointment = (resizeType, { event, start, end }) => {
    if(this._isShouldAllowCreateAppoinment()){
      showErrorMessage("Appointments for inactive client/staff cannot be modified");
      return;
    }
    const appointment = { ...event, start, end };

    let alertConfig = {
      customButtons: [{
        name: 'Resize',
        handleClick: this.handleMoveAppointmentClick,
        param: appointment,
      }, {
        name: 'Cancel',
        handleClick: () => Alert.closeAll(),
        param: null,
      }],
    };
    let movedDate = moment(end).format('MM/DD/YYYY'),
      movedStartTime = moment(start).format('h:mm a'),
      movedEndTime = moment(end).format('h:mm a'),
      startSessionDate = moment(start).format("YYYY-MM-DD"),
      endSessionDate = moment(end).format("YYYY-MM-DD");

    let sessionDate  = moment(event.start).format('MM/DD/YYYY');
      // var ms = moment(start,"MM/DD/YYYY HH:mm:ss").isBefore(moment(end,"MM/DD/YYYY HH:mm:ss"));      
      // console.log('moment(movedDate,"MM/DD/YYYY").isSame(moment(sessionDate,"MM/DD/YYYY"))...........',moment(movedDate,"MM/DD/YYYY").isSame(moment(sessionDate,"MM/DD/YYYY")))
      //  console.log('moment(start,"MM/DD/YYYY HH:mm:ss").isBefore(moment(end,"MM/DD/YYYY HH:mm:ss"))...........',moment(start,"MM/DD/YYYY HH:mm:ss").isBefore(moment(end,"MM/DD/YYYY HH:mm:ss")))
      //  console.log('moment(movedDate,"MM/DD/YYYY")........',moment(movedDate,"MM/DD/YYYY"))
      //  console.log('moment(sessionDate,"MM/DD/YYYY")........',moment(sessionDate,"MM/DD/YYYY"))
      //  console.log('moment(start).format("YYYY-MM-DD")........',moment(start).format("YYYY-MM-DD"))
      //   console.log('moment(end).format("YYYY-MM-DD")........',moment(end).format("YYYY-MM-DD"))
      //  console.log('moment(start,"YYYY-MM-DD").isSame(moment(end,"YYYY-MM-DD"))........',moment(startSessionDate).isSame(moment(endSessionDate)))

      if(moment(movedDate,"MM/DD/YYYY").isSame(moment(sessionDate,"MM/DD/YYYY")) && moment(start,"MM/DD/YYYY HH:mm:ss").isBefore(moment(end,"MM/DD/YYYY HH:mm:ss")) && moment(startSessionDate).isSame(moment(endSessionDate)))
      {
          //alertConfirmation(`Appointment will be Resized to ${movedDate} from ${movedStartTime} - ${movedEndTime}.`, alertConfig);
          alertConfirmation(`Appointment will be changed to ${movedStartTime} - ${movedEndTime}.`, alertConfig);
      }
      else
      {        
        showErrorMessage('Appointment time is invalid');
      }

  }

  _isShouldAllowCreateAppoinment(){
    let isInActive = false;

    if(this.state.isShowInActivePatientsActive){
      isInActive = true;
    }else if(this.state.isShowInActiveStaffActive){
      isInActive = true;
    }else if(this.state.isShowInActivePatientsActive && this.state.selectedPatient.length){
      isInActive = true;
    } else if(this.state.isShowInActiveStaffActive && this.state.selectedStaff.length){
      isInActive = true;
    }

    // console.log("_isShouldAllowCreateAppoinment",isInActive);

    return isInActive;
  }

  _showAppointmentDialogBasedOnAgencyName(agencyName,firstDialog,secondDialog){
    return (agencyName.toUpperCase() === VIP || agencyName.toUpperCase() === 'DEMO' || agencyName.toUpperCase() === CBF || agencyName.toUpperCase() === HYPERIONCENTER || agencyName.toUpperCase() === 'MOMMYANGELSSPECIALTYCARE') ?
              firstDialog :
              secondDialog ;
  }

  render() {

    let filteredUsersAvailability = null,
      singleSelectedPatientName = null;
    let { selectedStaff, staffsAvailibility } = this.state;
    if (!this.state.patient_id) {
      if (this.state.currentView !== 'resource') {
        if (selectedStaff && selectedStaff.length === 1) {
          filteredUsersAvailability = staffsAvailibility || null;
        }
      } else {
        filteredUsersAvailability = staffsAvailibility || null;
      }
    }

    let selectedOrgLocations = [];
    if (this.state.selectedLocation && this.state.selectedLocation.length) {
      selectedOrgLocations = this.props.userLocationList.filter((obj) => this.state.selectedLocation.includes(obj.id));
    }

    if (this.state.selectedPatient && this.state.selectedPatient.length === 1) {
      let selectedPatientObj = this.props.patientList.find((obj) => obj.id === this.state.selectedPatient[0]);
      singleSelectedPatientName = selectedPatientObj ? selectedPatientObj.value : null;
    }

    let formats = {
      dayFormat: (date, culture, localizer) =>
        localizer.format(date, 'ddd MM/DD', culture),
    //   selectRangeFormat: ({ start, end }, culture, local) =>
    // local.format(start, { date: 'short' }, culture) + ' to ' +
    // local.format(end, { date: 'short' }, culture),
      // monthHeaderFormat: (date, culture, localizer) =>
      //   localizer.format(date, 'ddd MM/DD', culture),
    };
    let scheduler_view = this.state.patient_id ? this.state.patient_views : this.state.all_views;
    let today = moment();

    let am8 = today.set('hour', this.state.startHour).set('minutes', this.state.startMinutes).toDate();
    let pm8 = today.set('hour', this.state.endHour).set('minutes', this.state.endMinutes).toDate();




    let appointementDialog = this._showAppointmentDialogBasedOnAgencyName(
      this.props.agencyName,
      <AppointmentDialogNewFeature
      isInActive={this._isShouldAllowCreateAppoinment()}
      selectedLocations={selectedOrgLocations}
      selectedStaffs={this.state.selectedStaff}
      selectedPatients={this.state.selectedPatient}
      singleSelectedPatientName={singleSelectedPatientName}
      dropdownPatientLocationTypes={this.props.dropdownPatientLocationTypes}
      dropdownModeOfMeeting={this.props.dropdownModeOfMeeting}
      dropdownSupervisionType={this.props.dropdownSupervisionType}
      dropdownAppointmentTypes={this.props.dropdownAppointmentTypes}
      slotDetails={this.state.slotInfo}
      closeDialog={this.closeDialog}
      refresh_appointments={this.get_all_appointments.bind(this)}
      patient_id={this.state.patient_id}
      getStaffsAndPatientsList={this.getStaffsAndPatientsList.bind(this)}
      viewClientSchedulesPermission={this.props.viewClientSchedulesPermission}
      modifyAfterRenderPermission={this.props.modifyAfterRenderPermission}
      editAppointmentTimeOnlyPermission={this.props.editAppointmentTimeOnlyPermission} 
      disableAppointmentEditing={this.props.disableAppointmentEditing}                
      isRequestFromPatientPortal={this.props.isRequestFromPatientPortal}
      editAppointmentAfterClaimSubmission={this.props.editAppointmentAfterClaimSubmission}
      showAddressTypeDuringAppointmentCreation={this.props.showAddressTypeDuringAppointmentCreation}
      viewTeamClientsOnlyPermission={this.props.viewTeamClientsOnlyPermission}
      lock_scheduler = {this.state.lock_scheduler}
      payRateTypeId={this.props.payRateTypeId}
      clinicalRoomId={this.props.clinicalRoomId}
      addMultipleStaffWhenCreatingNonBillableSession={this.props.addMultipleStaffWhenCreatingNonBillableSession}
      modifySessionTimeAfterClaimSubmission={this.props.modifySessionTimeAfterClaimSubmission}
      patientInsuranceId={this.state.slotInfo ? this.state.slotInfo.patientInsuranceId :null}
      />,
      <AppointmentDialog
        isInActive={this._isShouldAllowCreateAppoinment()}
        selectedLocations={selectedOrgLocations}
        selectedStaffs={this.state.selectedStaff}
        selectedPatients={this.state.selectedPatient}
        singleSelectedPatientName={singleSelectedPatientName}
        dropdownPatientLocationTypes={this.props.dropdownPatientLocationTypes}
        dropdownModeOfMeeting={this.props.dropdownModeOfMeeting}
        dropdownSupervisionType={this.props.dropdownSupervisionType}
        dropdownAppointmentTypes={this.props.dropdownAppointmentTypes}
        slotDetails={this.state.slotInfo}
        closeDialog={this.closeDialog}
        refresh_appointments={this.get_all_appointments.bind(this)}
        patient_id={this.state.patient_id}
        getStaffsAndPatientsList={this.getStaffsAndPatientsList.bind(this)}
        viewClientSchedulesPermission={this.props.viewClientSchedulesPermission}
        modifyAfterRenderPermission={this.props.modifyAfterRenderPermission}
        editAppointmentTimeOnlyPermission={this.props.editAppointmentTimeOnlyPermission} 
        disableAppointmentEditing={this.props.disableAppointmentEditing}                
        isRequestFromPatientPortal={this.props.isRequestFromPatientPortal}
        editAppointmentAfterClaimSubmission={this.props.editAppointmentAfterClaimSubmission}
        showAddressTypeDuringAppointmentCreation={this.props.showAddressTypeDuringAppointmentCreation}
        viewTeamClientsOnlyPermission={this.props.viewTeamClientsOnlyPermission}
        lock_scheduler = {this.state.lock_scheduler}
        payRateTypeId={this.props.payRateTypeId}
        clinicalRoomId={this.props.clinicalRoomId}
        addMultipleStaffWhenCreatingNonBillableSession={this.props.addMultipleStaffWhenCreatingNonBillableSession}
        modifySessionTimeAfterClaimSubmission={this.props.modifySessionTimeAfterClaimSubmission}
        patientInsuranceId={this.state.slotInfo ? this.state.slotInfo.patientInsuranceId :null}
      />
      )


    return (
      <div>
        <h2 className="page_title">{this.props.headerTitle}</h2>
        {this.props.showPatientBannerInfo && <PatientInfo patientId={this.state.patient_id} />}
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            {this.state.showDialog ?

              // (this.props.agencyName.toUpperCase() === VIP) ? // || this.props.agencyName.toUpperCase() === 'DEMO' || this.props.agencyName.toUpperCase() === ADASTRA

              // <AppointmentDialogNewFeature
              //   selectedLocations={selectedOrgLocations}
              //   selectedStaffs={this.state.selectedStaff}
              //   selectedPatients={this.state.selectedPatient}
              //   singleSelectedPatientName={singleSelectedPatientName}
              //   dropdownPatientLocationTypes={this.props.dropdownPatientLocationTypes}
              //   dropdownModeOfMeeting={this.props.dropdownModeOfMeeting}
              //   dropdownSupervisionType={this.props.dropdownSupervisionType}
              //   dropdownAppointmentTypes={this.props.dropdownAppointmentTypes}
              //   slotDetails={this.state.slotInfo}
              //   closeDialog={this.closeDialog}
              //   refresh_appointments={this.get_all_appointments.bind(this)}
              //   patient_id={this.state.patient_id}
              //   getStaffsAndPatientsList={this.getStaffsAndPatientsList.bind(this)}
              //   viewClientSchedulesPermission={this.props.viewClientSchedulesPermission}
              //   modifyAfterRenderPermission={this.props.modifyAfterRenderPermission}
              //   editAppointmentTimeOnlyPermission={this.props.editAppointmentTimeOnlyPermission} 
              //   disableAppointmentEditing={this.props.disableAppointmentEditing}                
              //   isRequestFromPatientPortal={this.props.isRequestFromPatientPortal}
              //   editAppointmentAfterClaimSubmission={this.props.editAppointmentAfterClaimSubmission}
              //   showAddressTypeDuringAppointmentCreation={this.props.showAddressTypeDuringAppointmentCreation}
              //   viewTeamClientsOnlyPermission={this.props.viewTeamClientsOnlyPermission}
              //   lock_scheduler = {this.state.lock_scheduler}
              //   payRateTypeId={this.props.payRateTypeId}
              //   clinicalRoomId={this.props.clinicalRoomId}
              //   addMultipleStaffWhenCreatingNonBillableSession={this.props.addMultipleStaffWhenCreatingNonBillableSession}
              //   modifySessionTimeAfterClaimSubmission={this.props.modifySessionTimeAfterClaimSubmission}
              // />

              // :

              // <AppointmentDialog
              //   selectedLocations={selectedOrgLocations}
              //   selectedStaffs={this.state.selectedStaff}
              //   selectedPatients={this.state.selectedPatient}
              //   singleSelectedPatientName={singleSelectedPatientName}
              //   dropdownPatientLocationTypes={this.props.dropdownPatientLocationTypes}
              //   dropdownModeOfMeeting={this.props.dropdownModeOfMeeting}
              //   dropdownSupervisionType={this.props.dropdownSupervisionType}
              //   dropdownAppointmentTypes={this.props.dropdownAppointmentTypes}
              //   slotDetails={this.state.slotInfo}
              //   closeDialog={this.closeDialog}
              //   refresh_appointments={this.get_all_appointments.bind(this)}
              //   patient_id={this.state.patient_id}
              //   getStaffsAndPatientsList={this.getStaffsAndPatientsList.bind(this)}
              //   viewClientSchedulesPermission={this.props.viewClientSchedulesPermission}
              //   modifyAfterRenderPermission={this.props.modifyAfterRenderPermission}
              //   editAppointmentTimeOnlyPermission={this.props.editAppointmentTimeOnlyPermission} 
              //   disableAppointmentEditing={this.props.disableAppointmentEditing}                
              //   isRequestFromPatientPortal={this.props.isRequestFromPatientPortal}
              //   editAppointmentAfterClaimSubmission={this.props.editAppointmentAfterClaimSubmission}
              //   showAddressTypeDuringAppointmentCreation={this.props.showAddressTypeDuringAppointmentCreation}
              //   viewTeamClientsOnlyPermission={this.props.viewTeamClientsOnlyPermission}
              //   lock_scheduler = {this.state.lock_scheduler}
              //   payRateTypeId={this.props.payRateTypeId}
              //   clinicalRoomId={this.props.clinicalRoomId}
              //   addMultipleStaffWhenCreatingNonBillableSession={this.props.addMultipleStaffWhenCreatingNonBillableSession}
              //   modifySessionTimeAfterClaimSubmission={this.props.modifySessionTimeAfterClaimSubmission}
              // />


              // this._showAppointmentDialogBasedOnAgencyName(
              //   this.props.agencyName,
              //   <AppointmentDialogNewFeature
              //   selectedLocations={selectedOrgLocations}
              //   selectedStaffs={this.state.selectedStaff}
              //   selectedPatients={this.state.selectedPatient}
              //   singleSelectedPatientName={singleSelectedPatientName}
              //   dropdownPatientLocationTypes={this.props.dropdownPatientLocationTypes}
              //   dropdownModeOfMeeting={this.props.dropdownModeOfMeeting}
              //   dropdownSupervisionType={this.props.dropdownSupervisionType}
              //   dropdownAppointmentTypes={this.props.dropdownAppointmentTypes}
              //   slotDetails={this.state.slotInfo}
              //   closeDialog={this.closeDialog}
              //   refresh_appointments={this.get_all_appointments.bind(this)}
              //   patient_id={this.state.patient_id}
              //   getStaffsAndPatientsList={this.getStaffsAndPatientsList.bind(this)}
              //   viewClientSchedulesPermission={this.props.viewClientSchedulesPermission}
              //   modifyAfterRenderPermission={this.props.modifyAfterRenderPermission}
              //   editAppointmentTimeOnlyPermission={this.props.editAppointmentTimeOnlyPermission} 
              //   disableAppointmentEditing={this.props.disableAppointmentEditing}                
              //   isRequestFromPatientPortal={this.props.isRequestFromPatientPortal}
              //   editAppointmentAfterClaimSubmission={this.props.editAppointmentAfterClaimSubmission}
              //   showAddressTypeDuringAppointmentCreation={this.props.showAddressTypeDuringAppointmentCreation}
              //   viewTeamClientsOnlyPermission={this.props.viewTeamClientsOnlyPermission}
              //   lock_scheduler = {this.state.lock_scheduler}
              //   payRateTypeId={this.props.payRateTypeId}
              //   clinicalRoomId={this.props.clinicalRoomId}
              //   addMultipleStaffWhenCreatingNonBillableSession={this.props.addMultipleStaffWhenCreatingNonBillableSession}
              //   modifySessionTimeAfterClaimSubmission={this.props.modifySessionTimeAfterClaimSubmission}
              //   />,
              //   <AppointmentDialog
              //     selectedLocations={selectedOrgLocations}
              //     selectedStaffs={this.state.selectedStaff}
              //     selectedPatients={this.state.selectedPatient}
              //     singleSelectedPatientName={singleSelectedPatientName}
              //     dropdownPatientLocationTypes={this.props.dropdownPatientLocationTypes}
              //     dropdownModeOfMeeting={this.props.dropdownModeOfMeeting}
              //     dropdownSupervisionType={this.props.dropdownSupervisionType}
              //     dropdownAppointmentTypes={this.props.dropdownAppointmentTypes}
              //     slotDetails={this.state.slotInfo}
              //     closeDialog={this.closeDialog}
              //     refresh_appointments={this.get_all_appointments.bind(this)}
              //     patient_id={this.state.patient_id}
              //     getStaffsAndPatientsList={this.getStaffsAndPatientsList.bind(this)}
              //     viewClientSchedulesPermission={this.props.viewClientSchedulesPermission}
              //     modifyAfterRenderPermission={this.props.modifyAfterRenderPermission}
              //     editAppointmentTimeOnlyPermission={this.props.editAppointmentTimeOnlyPermission} 
              //     disableAppointmentEditing={this.props.disableAppointmentEditing}                
              //     isRequestFromPatientPortal={this.props.isRequestFromPatientPortal}
              //     editAppointmentAfterClaimSubmission={this.props.editAppointmentAfterClaimSubmission}
              //     showAddressTypeDuringAppointmentCreation={this.props.showAddressTypeDuringAppointmentCreation}
              //     viewTeamClientsOnlyPermission={this.props.viewTeamClientsOnlyPermission}
              //     lock_scheduler = {this.state.lock_scheduler}
              //     payRateTypeId={this.props.payRateTypeId}
              //     clinicalRoomId={this.props.clinicalRoomId}
              //     addMultipleStaffWhenCreatingNonBillableSession={this.props.addMultipleStaffWhenCreatingNonBillableSession}
              //     modifySessionTimeAfterClaimSubmission={this.props.modifySessionTimeAfterClaimSubmission}
              //   />
              //   )
              appointementDialog
              : null
            }

            {
              this.state.showCancelAppointmentDialog ?
                <CancelAppointmentDialog
                  patientAppointmentId={this.state.slotInfo ? this.state.slotInfo.id : null}
                  //masterCancelType={this.props.master_data ? this.props.master_data.masterCancelType : []}
                  showCancelAppointmentDialog={this.state.showCancelAppointmentDialog}
                  closeCancelAppointmentDialog={this.closeCancelAppointmentDialog}/>
                : null
            }
            {this.props.patientId ?
              '' :
              <div>
                <div className="stfselection">
                  <div className="col-12">
                    <div className="row">
                      <div className='col-sm-4 cushgt'>
                        <div className="sech_item">
                          <p>Location : </p>
                          <span className={this.state.selectAllLocation ? 'active' : ''} onClick={this.selectAll.bind(this, 'Location')}>Select All </span>
                          <span className={this.state.deSelectAllLocation ? 'active' : ''} onClick={this.deselectAll.bind(this, 'Location')}> Deselect All</span>
                        </div>
                        <Field
                          name="Location"
                          label="Location"
                          handleNewRequest={this.handleChange}
                          options={this.state.allLocation}
                          selectedTab={this.state.locationActiveTab}
                          component={renderAutoCompleteScheduling} />
                      </div>
                      <div className='col-sm-4 cushgt'>
                        <div className="sech_item">
                          <p>Staff : </p>
                          {/* <NavLink exact to="#">All</NavLink>*/}
                          <span className={this.state.selectAllStaff ? 'active' : ''} onClick={this.selectAll.bind(this, 'Staff')}>Select All </span>
                          <span className={this.state.deSelectAllStaff ? 'active' : ''} onClick={this.deselectAll.bind(this, 'Staff')}> Deselect All </span>
                          <span className={this.state.tagStaff ? 'active' : ''} onClick={this.tagSelection.bind(this, 'StaffTags')}>Tag</span>
                          <span className={this.state.isShowInActiveStaffActive ? 'active': '' } onClick={this.showInActiveSelection.bind(this, 'Staff')}>{this.state.isShowInActiveStaffActive?'Show Active':'Show Inactive'}</span>
                        </div>
                        {!this.state.tagStaff ? // multi select tag/staff view ...
                            <Field
                              name="Staffs"
                              label="Staff"
                              handleNewRequest={this.handleChange}
                              // selected={this.state.loginStaff}
                              options={this.state.allStaff}
                              selectedTab={this.state.staffActiveTab}
                              component={renderAutoCompleteScheduling}/>
                          : <Field
                            name="StaffTags"
                            label="Staff Tags"
                            handleNewRequest={this.handleChange}
                            options={this.state.allStaffTags}
                            // selectedTab={this.state.staffActiveTab}
                            component={renderAutoCompleteScheduling}/> }
                      </div>
                      {/* {!this.props.viewClientSchedulesPermission || this.state.IsStaffView ? '' : */}
                      {!this.props.viewClientSchedulesPermission ? '' :
                        <div className='col-sm-4 cushgt'>
                          <div className="sech_item">
                            <p>Client: </p>
                            <span className={this.state.selectAllPatient ? 'active' : ''} onClick={this.selectAll.bind(this, 'Client')}>Select All </span>
                            <span className={this.state.deSelectAllPatient ? 'active' : ''} onClick={this.deselectAll.bind(this, 'Client')}> Deselect All </span>
                            <span className={this.state.tagClient ? 'active' : ''} onClick={this.tagSelection.bind(this, 'ClientTags')}>Tag</span>
                            <span className={this.state.isShowInActivePatientsActive ? 'active' : '' } onClick={this.showInActiveSelection.bind(this, 'Client')}>{this.state.isShowInActivePatientsActive?'Show Active':'Show Inactive'}</span>
                          </div>
                          {!this.state.tagClient ? // multi select client/tag view
                            <Field
                              name="Patient"
                              label="Client"
                              handleNewRequest={this.handleChange}
                              options={this.state.allPatient}
                              selectedTab={this.state.clientActiveTab}
                              component={renderAutoCompleteScheduling}/>
                            : <Field
                              name="ClientTags"
                              label="Client Tags"
                              handleNewRequest={this.handleChange}
                              options={this.state.allClientTags}
                              // selectedTab={this.state.clientActiveTab}
                              component={renderAutoCompleteScheduling}/> }
                        </div>
                      }
                                       
                    </div>                    
                    {this.state.enableClinicalRoomFilter ?
                      <div className="row">
                        <div className='col-sm-4 cushgt'>
                          <div className="sech_item">
                            <p>Activity: </p>
                            <span className={this.state.selectAllActivity ? 'active' : ''} onClick={this.selectAll.bind(this, 'Activity')}>Select All </span>
                            <span className={this.state.deSelectAllActivity ? 'active' : ''} onClick={this.deselectAll.bind(this, 'Activity')}> Deselect All </span>
                          </div>
                          <Field
                            name="Activity"
                            label="Activity"
                            handleNewRequest={this.handleChange}
                            options={this.state.allActivity}
                            selectedTab={this.state.activityActiveTab}
                            component={renderAutoCompleteScheduling}/>
                      </div>   
                        <div className='col-sm-4 cushgt'>
                          <div className="sech_item">
                            <p>Therapy Room: </p>
                            <span className={this.state.selectAllClinicalRoom ? 'active' : ''} onClick={this.selectAll.bind(this, 'ClinicalRoom')}>Select All </span>
                            <span className={this.state.deSelectAllClinicalRoom ? 'active' : ''} onClick={this.deselectAll.bind(this, 'ClinicalRoom')}> Deselect All </span>
                          </div>
                          <Field
                            name="ClinicalRoom"
                            label="Therapy Room"
                            handleNewRequest={this.handleChange}
                            options={this.state.allClinicalRoom}
                            selectedTab={this.state.clinicalRoomActiveTab}
                            component={renderAutoCompleteScheduling}/>
                        </div>
                        {(this.props.agencyName.toUpperCase() === 'SANTACRUZABA' || this.props.agencyName.toUpperCase() === 'CBC' || this.props.agencyName.toUpperCase() === 'CBF') ?  null :    
                          <div className='col-sm-4 mt-20'>
                            <Field
                              name="IsDisplayNumberOfHours"
                              label="Display # of Hours"                 
                              className="custm_check_scheduler"                                         
                              onChange={this.handleDisplayNumberOfHours}
                              component={renderCheckBox}                            
                            />
                          </div>}
                      </div>
                    : null}                    
                  </div>
                </div>
              </div>
            }
            <div className="calandericon">
              <div className="customdateschedule">
                <RaisedButton className="dateicon" onTouchTap={this.openDatePicker.bind(this)}>
                  <i className="material-icons">date_range</i>
                </RaisedButton>
                <DatePicker
                  ref="dp"
                  name="schedulerDate"
                  id="datefieldicon"
                  container="inline"
                  locale="en-US"
                  fullWidth={true}
                  minDate={new Date(1900, 1, 1)}
                  value={this.state.schedulerDate ? new Date(this.state.schedulerDate) : {}}
                  autoOk={true}
                  style={{ display: 'inline-block', width: '0px', visibility: 'hidden' }}
                  onChange={(event, value) => this.onSchedulerDateChange(value) } />
                {/* <Field
                    name="schedulerDate"
                    placeholder=""
                    component={renderDateField}
                    locale="en-US"
                    selected={this.state.schedulerDate}
                    onDateChange={this.onDateChange}
                  />

                  */}
              </div>
            </div>

              <DragAndDropCalendar
                selectable
                resizable
                min={am8}
                max={pm8}
                // timeslots={1}
                events={this.state.appointments}
                resources={this.state.resource_list}
                defaultView={this.state.currentView}
                scrollToTime={new Date(1970, 1, 1, 6)}
                defaultDate={new Date()}
                date={this.state.schedulerDate}
                formats={formats}
                views={scheduler_view}
                onEventDrop={(event) => this.moveAppointment(event)}
                onEventResize={this.resizeAppointment}
                draggableAccessor= 'isDragable'
                resizableAccessor= 'isDragable'
                onSelectEvent={(event) => this.openDialog(event)}
                onView={(e) => this.handleStaffView(e)}
                eventPropGetter={(event, date, end, isSelected) => this.eventStyleGetter(event, date, end, isSelected)}
                onSelectSlot={(slotInfo) => this.openDialog(slotInfo)}
                onNavigate={this.onNavigateMonth}
                usersAvailability = {filteredUsersAvailability}
                totalScheduledHours={this.state.totalScheduledHours}
                totalRenderedHours={this.state.totalRenderedHours}
                totalCanceledHours={this.state.totalCanceledHours}
                totalBillableHours={this.state.totalBillableHours}
                //isEnableBillableHours={(this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === CBF) ? 1 : 0}
                isEnableBillableHours={1}
                //step={this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === AIP || this.props.agencyName.toUpperCase() === FUTURES ? 15 : 30}
                step={this.props.agencyName.toUpperCase() === FUTURES ? 15 : 30}
              />
          </div>
        </div>
      </div>
    );
  }
}

const selector = formValueSelector('scheduleForm');

Scheduling = DragDropContext(HTML5Backend)(Scheduling);

const mapStateToProps = (state) => {
  let dropdownPatientLocationTypes = [], dropdownModeOfMeeting, dropdownSupervisionType, dropdownAppointmentTypes = [];
  let payRateTypeId = [], clinicalRoomId = [];
  if (state.scheduling.master_data) {
    dropdownPatientLocationTypes = state.scheduling.master_data.masterPatientLocation || [];
    dropdownModeOfMeeting = state.scheduling.master_data.modeOfMeeting || [];
    dropdownSupervisionType = state.scheduling.master_data.supervisionType || [];
    dropdownAppointmentTypes = state.scheduling.master_data.appointmentType || [];
    payRateTypeId = state.scheduling.master_data.payRateType || [];
    clinicalRoomId = state.scheduling.master_data.masterClinicalRoom || [];    
  }

  let currentLocationId = state.login.currentLocationId;
  let selectedLocation = [];
  let staffsByLocation = [];
  let patientsByLocation = [];
  let clientsByLocation = [];
  let activityList = [];
  let initialValuesData = null;
  let userLocationList = [];

  if (state.login.userLocationList) {

    userLocationList = state.login.userLocationList.map((obj) => {
      if (obj.id === currentLocationId) {
        selectedLocation.push(obj.id);
      }
      return {
        id: obj.id,
        value: obj.locationName,
      };
    });

  }
  if (state.scheduling.staffsAndPatientsByLocation) {
    let allList = state.scheduling.staffsAndPatientsByLocation.data;
    staffsByLocation = allList.staff;
    patientsByLocation = allList.patients;
    activityList = allList.appointmentType;
  }
  let selectedStaff = [],
    selectedPatient = [];
  if (state.login.loginUserInfo && state.login.loginUserInfo.id) {
    selectedStaff = [state.login.loginUserInfo.id];
  }
  if (state.scheduling.updateSelectedSchedulerData) {
    selectedLocation = state.scheduling.updateSelectedSchedulerData.selectedLocation;
    selectedStaff = state.scheduling.updateSelectedSchedulerData.selectedStaff;
    selectedPatient = state.scheduling.updateSelectedSchedulerData.selectedPatient;
  }
  initialValuesData = {
    'Location': selectedLocation,
    'Staffs': selectedStaff || null,
    'Patient': selectedPatient || null,
  };
  return {
    isShowInActiveStaffActive:state.scheduling.isShowInActiveStaffActive,
    isShowInActivePatientsActive:state.scheduling.isShowInActivePatientsActive,
    loading: state.scheduling.loading,
    appointments: state.scheduling.appointments_list,
    master_data: state.scheduling.master_data,
    dropdownPatientLocationTypes: dropdownPatientLocationTypes,
    dropdownModeOfMeeting: dropdownModeOfMeeting,
    dropdownSupervisionType: dropdownSupervisionType,
    dropdownAppointmentTypes: dropdownAppointmentTypes,
    payRateTypeId: payRateTypeId,
    clinicalRoomId: clinicalRoomId,
    masterTags: state.scheduling.masterTags,
    //activityList: state.scheduling.master_data.appointmentType,
    clinicalRoomList: state.scheduling.master_data.masterClinicalRoom,
    patientList: patientsByLocation, // state.patient.patientList,
    activityList: activityList,
    appointment_deleted: state.scheduling.appointment_deleted,
    appointment_created: state.scheduling.appointment_created,
    staffs: staffsByLocation, // state.user.staffList,
    userLocationList: userLocationList,
    Staffs: selector(state, 'Staffs'),
    currentLocation: selectedLocation,
    officeHours: state.scheduling.office_hours,
    // loginStaff: selectedStaff,
    staffsAvailibility: state.scheduling.staffsAvailibility,
    staffsAndPatientsByLocation: state.scheduling.staffsAndPatientsByLocation,
    onlyInActiveStaffAndPatientsByLocation: state.scheduling.onlyInActiveStaffAndPatientsByLocation,
    cancelledAppointment: state.scheduling.cancelledAppointment,
    unCancelledAppointment: state.scheduling.unCancelledAppointment,
    selectedSchedulerData: state.scheduling.updateSelectedSchedulerData,
    checkValidAppointment_inUndoCancel: state.scheduling.checkValidAppointment_inUndoCancel,
    patientAuthorizationDetailsWithUpdateAppointment: state.scheduling.patientAuthorizationDetailsWithUpdateAppointment,
    updateAppointmentStatusDetail: state.scheduling.updateAppointmentStatusDetail,
    initialValues: initialValuesData,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    staffListByTags: state.user.staffs_list_ByTags && state.user.staffs_list_ByTags.data ? state.user.staffs_list_ByTags.data : [],
    clientsListByTags: state.user.clients_list_ByTags && state.user.clients_list_ByTags.data ? state.user.clients_list_ByTags.data : [],
    app_config: state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null,
  };
};

Scheduling = reduxForm({
  form: 'scheduleForm',
})(Scheduling);

export default connect(mapStateToProps, {
  getPatients,
  getAllPatients,
  getPatientsByLocation,
  getAppointments,
  deleteAppointmentData,
  getMasterData,
  createAppointment,
  getOfficeHours,
  getMasterTags,
  getStaffsAvailability,
  getClientsAvailability,
  getAppointmentData,
  getStaffsAndPatientsByLocation,
  undoCancelledAppointment,
  updateSelectedSchedulerData,
  checkIsValidAppointment,
  getPatientAuthorizationDetails,
  updatePendingAppointmentStatus,
  getStaffByTags,
  getClientByTags,
  getAppConfigList,
  checkClinicalRoomAvailablity,
  setIsShowInActiveFlages,
  getInActiveStaffAndPatientByLocation,
  getOnlyInActiveStaffAndPatientsByLocation,
})(Scheduling);



// WEBPACK FOOTER //
// ./src/modules/scheduling/scheduler.js